import { useEffect } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/loader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const MatchTalentHire = () => {
  const { isLoading2 } = useSelector((state) => state.coach.coach);
  const { isLoading } = useSelector((state) => state.coach.auth);

  const user = { name: "find-a-coach", role: "coach" };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  if (isLoading2 || isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <MenuLayout user={user}>
        {({ openSignUp }) => (
          <>
            <section
              class="ct_nuglow_subsciption_left_bg"
              style={{ backgroundColor: "var(--dark_blue)" }}
            >
              <div class="container-fluid">
                <div class="row align-items-end">
                  <div className="col-lg-7 mb-4 mb-lg-0 px-0">
                    <img
                      src="../assets/img/match_talent_bg.png"
                      className="ct_img_h_371 "
                    />
                  </div>
                  <div className="col-lg-5 mb-4 mb-lg-0 ps-0">
                    <div className="ct_py_60_ct_px_70">
                      <h2
                        className="ct_fs_32 ct_mb_50 text-white"
                        style={{ maxWidth: "500px" }}
                      >
                        Hire Smarter, Move{" "}
                        <span className="ct_yellow_text">Faster</span>
                      </h2>
                      <p
                        className=" text-white ct_fs_18"
                        style={{ maxWidth: "457px" }}
                      >
                        Refine your skills, attract premium clients, and grow
                        with expert guidance.
                      </p>
                      <div
                        className="mt-4 position-relative"
                        style={{ maxWidth: "300px" }}
                      >
                        <input
                          className="text"
                          class="form-control ct_input ct_input_ps_40"
                          placeholder="Search...."
                        />
                        <i class="fa-solid fa-magnifying-glass ct_input_icon_left"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="ct_px_40 ct_py_50 ct_nuforge_lightblue_shape_main_34 mb-0 ct_nuglow_yellow_shape_main_34 ct_job_list__shape_main_123  ct_match_talent_shape_bg">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="ct_fs_32 ct_darkblue_text ct_mb_40">
                      Job Categories
                    </h3>

                    <ul className="ct_job_categories_tags">
                      <li>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.8067 4.69305C13.58 4.91971 13.36 5.13971 13.3533 5.35971C13.3333 5.57305 13.56 5.79305 13.7733 5.99971C14.0933 6.33305 14.4067 6.63305 14.3933 6.95971C14.38 7.28638 14.04 7.62638 13.7 7.95971L10.9467 10.7197L10 9.77305L12.8333 6.94638L12.1933 6.30638L11.2467 7.24638L8.74667 4.74638L11.3067 2.19305C11.5667 1.93305 12 1.93305 12.2467 2.19305L13.8067 3.75305C14.0667 3.99971 14.0667 4.43305 13.8067 4.69305ZM2 11.4997L8.37333 5.11971L10.8733 7.61971L4.5 13.9997H2V11.4997Z"
                            fill="#023047"
                          />
                        </svg>
                        UI/UX Design
                      </li>
                      <li>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.66536 3.33398H9.33203V12.6673H6.66536V3.33398ZM3.33203 12.6673V6.66732H5.9987V12.6673H3.33203ZM4.66536 3.33398C4.31174 3.33398 3.9726 3.47446 3.72256 3.72451C3.47251 3.97456 3.33203 4.3137 3.33203 4.66732C3.33203 5.02094 3.47251 5.36008 3.72256 5.61013C3.9726 5.86017 4.31174 6.00065 4.66536 6.00065C5.01899 6.00065 5.35812 5.86017 5.60817 5.61013C5.85822 5.36008 5.9987 5.02094 5.9987 4.66732C5.9987 4.3137 5.85822 3.97456 5.60817 3.72451C5.35812 3.47446 5.01899 3.33398 4.66536 3.33398ZM9.9987 3.33398H12.6654V6.00065H9.9987V3.33398ZM12.6654 6.66732H9.9987V9.33398H12.6654V6.66732Z"
                            fill="#023047"
                          />
                        </svg>
                        Graphic Design
                      </li>
                      <li>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.33203 9.99935H8.66536V11.3327H7.33203V9.99935ZM7.33203 4.66602H8.66536V8.66602H7.33203V4.66602Z"
                            fill="#023047"
                          />
                          <path
                            d="M3.33984 0.666016V15.3327H12.6665V0.666016H3.33984ZM11.3332 11.9993H4.66651V3.99935H11.3332V11.9993Z"
                            fill="#023047"
                          />
                        </svg>
                        Mobile App Development
                      </li>
                      <li>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.0013 1.33594H2.0013C1.648 1.33699 1.30948 1.47781 1.05966 1.72763C0.809839 1.97745 0.669024 2.31597 0.667969 2.66927V10.6693C0.669024 11.0226 0.809839 11.3611 1.05966 11.6109C1.30948 11.8607 1.648 12.0015 2.0013 12.0026H6.66797V13.3359H5.33464V14.6693H10.668V13.3359H9.33464V12.0026H14.0013C14.3546 12.0015 14.6931 11.8607 14.9429 11.6109C15.1928 11.3611 15.3336 11.0226 15.3346 10.6693V2.66927C15.3336 2.31597 15.1928 1.97745 14.9429 1.72763C14.6931 1.47781 14.3546 1.33699 14.0013 1.33594ZM7.1693 9.11327L4.00264 5.9466L4.9453 5.0046L7.1693 7.2286L11.0593 3.33794L12.0026 4.28127L7.1693 9.11327Z"
                            fill="#023047"
                          />
                        </svg>
                        Web Development
                      </li>
                      <li>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M13.3346 2.66732H2.66797C2.49116 2.66732 2.32159 2.73756 2.19656 2.86258C2.07154 2.9876 2.0013 3.15717 2.0013 3.33398V12.6673C2.0013 12.8441 2.07154 13.0137 2.19656 13.1387C2.32159 13.2637 2.49116 13.334 2.66797 13.334H13.3346C13.5114 13.334 13.681 13.2637 13.806 13.1387C13.9311 13.0137 14.0013 12.8441 14.0013 12.6673V3.33398C14.0013 3.15717 13.9311 2.9876 13.806 2.86258C13.681 2.73756 13.5114 2.66732 13.3346 2.66732ZM2.66797 1.33398C2.13754 1.33398 1.62883 1.5447 1.25376 1.91977C0.878682 2.29484 0.667969 2.80355 0.667969 3.33398V12.6673C0.667969 13.1978 0.878682 13.7065 1.25376 14.0815C1.62883 14.4566 2.13754 14.6673 2.66797 14.6673H13.3346C13.8651 14.6673 14.3738 14.4566 14.7488 14.0815C15.1239 13.7065 15.3346 13.1978 15.3346 12.6673V3.33398C15.3346 2.80355 15.1239 2.29484 14.7488 1.91977C14.3738 1.5447 13.8651 1.33398 13.3346 1.33398H2.66797ZM4.0013 4.66732H5.33464V6.00065H4.0013V4.66732ZM7.33464 4.66732C7.15782 4.66732 6.98826 4.73756 6.86323 4.86258C6.73821 4.9876 6.66797 5.15717 6.66797 5.33398C6.66797 5.5108 6.73821 5.68036 6.86323 5.80539C6.98826 5.93041 7.15782 6.00065 7.33464 6.00065H11.3346C11.5114 6.00065 11.681 5.93041 11.806 5.80539C11.9311 5.68036 12.0013 5.5108 12.0013 5.33398C12.0013 5.15717 11.9311 4.9876 11.806 4.86258C11.681 4.73756 11.5114 4.66732 11.3346 4.66732H7.33464ZM5.33464 7.33398H4.0013V8.66732H5.33464V7.33398ZM6.66797 8.00065C6.66797 7.82384 6.73821 7.65427 6.86323 7.52925C6.98826 7.40422 7.15782 7.33398 7.33464 7.33398H11.3346C11.5114 7.33398 11.681 7.40422 11.806 7.52925C11.9311 7.65427 12.0013 7.82384 12.0013 8.00065C12.0013 8.17746 11.9311 8.34703 11.806 8.47205C11.681 8.59708 11.5114 8.66732 11.3346 8.66732H7.33464C7.15782 8.66732 6.98826 8.59708 6.86323 8.47205C6.73821 8.34703 6.66797 8.17746 6.66797 8.00065ZM5.33464 10.0007H4.0013V11.334H5.33464V10.0007ZM6.66797 10.6673C6.66797 10.4905 6.73821 10.3209 6.86323 10.1959C6.98826 10.0709 7.15782 10.0007 7.33464 10.0007H11.3346C11.5114 10.0007 11.681 10.0709 11.806 10.1959C11.9311 10.3209 12.0013 10.4905 12.0013 10.6673C12.0013 10.8441 11.9311 11.0137 11.806 11.1387C11.681 11.2637 11.5114 11.334 11.3346 11.334H7.33464C7.15782 11.334 6.98826 11.2637 6.86323 11.1387C6.73821 11.0137 6.66797 10.8441 6.66797 10.6673Z"
                            fill="#023047"
                          />
                        </svg>
                        Copy Writing
                      </li>
                      <li>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.8067 4.69305C13.58 4.91971 13.36 5.13971 13.3533 5.35971C13.3333 5.57305 13.56 5.79305 13.7733 5.99971C14.0933 6.33305 14.4067 6.63305 14.3933 6.95971C14.38 7.28638 14.04 7.62638 13.7 7.95971L10.9467 10.7197L10 9.77305L12.8333 6.94638L12.1933 6.30638L11.2467 7.24638L8.74667 4.74638L11.3067 2.19305C11.5667 1.93305 12 1.93305 12.2467 2.19305L13.8067 3.75305C14.0667 3.99971 14.0667 4.43305 13.8067 4.69305ZM2 11.4997L8.37333 5.11971L10.8733 7.61971L4.5 13.9997H2V11.4997Z"
                            fill="#023047"
                          />
                        </svg>
                        SEO Writing
                      </li>
                      <li>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.6654 5.33333V9.33333C13.7987 9.33333 14.6654 8.46667 14.6654 7.33333C14.6654 6.2 13.7987 5.33333 12.6654 5.33333ZM7.33203 4.66667H2.66536C1.93203 4.66667 1.33203 5.26667 1.33203 6V8.66667C1.33203 9.4 1.93203 10 2.66536 10H3.33203V12C3.33203 12.7333 3.93203 13.3333 4.66536 13.3333H5.9987V10H7.33203L9.9987 12.6667H11.332V2H9.9987L7.33203 4.66667Z"
                            fill="#023047"
                          />
                        </svg>
                        Digital Marketing
                      </li>
                      <li>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_5692_1479)">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M1.80022 1.02706C1.80022 0.799736 1.70992 0.581719 1.54917 0.420973C1.38843 0.260228 1.17041 0.169922 0.94308 0.169922C0.715752 0.169922 0.497734 0.260228 0.336989 0.420973C0.176243 0.581719 0.0859375 0.799736 0.0859375 1.02706V14.9745C0.0859375 15.4476 0.469938 15.8316 0.94308 15.8316H14.8905C15.1178 15.8316 15.3359 15.7413 15.4966 15.5806C15.6573 15.4198 15.7477 15.2018 15.7477 14.9745C15.7477 14.7472 15.6573 14.5291 15.4966 14.3684C15.3359 14.2077 15.1178 14.1174 14.8905 14.1174H1.79908L1.80022 1.02706ZM11.6825 2.77906C11.5578 2.69013 11.4165 2.62718 11.267 2.59394C11.1175 2.5607 10.9628 2.55786 10.8121 2.58557C10.6615 2.61329 10.518 2.67101 10.3901 2.75529C10.2622 2.83958 10.1525 2.94871 10.0677 3.07621L6.54994 8.35164L4.85394 6.65564C4.74775 6.54938 4.62168 6.46507 4.48292 6.40754C4.34415 6.35 4.19542 6.32036 4.0452 6.32031C3.89498 6.32026 3.74622 6.34979 3.60742 6.40723C3.46861 6.46467 3.34248 6.54888 3.23622 6.65506C3.12996 6.76125 3.04566 6.88732 2.98813 7.02608C2.93059 7.16485 2.90095 7.31358 2.9009 7.4638C2.90085 7.61402 2.93038 7.76278 2.98782 7.90158C3.04525 8.04039 3.12947 8.16652 3.23565 8.27278L5.91794 10.9539C6.03747 11.0737 6.18211 11.1654 6.34141 11.2225C6.50071 11.2795 6.67069 11.3005 6.83908 11.2839C7.00747 11.2673 7.17007 11.2135 7.31514 11.1264C7.46021 11.0393 7.58412 10.921 7.67794 10.7802L11.3134 5.32535L14.1088 7.32192C14.3555 7.49802 14.6621 7.5689 14.9611 7.51897C15.2601 7.46903 15.527 7.30236 15.7031 7.05564C15.8792 6.80891 15.9501 6.50233 15.9001 6.20334C15.8502 5.90436 15.6835 5.63745 15.4368 5.46135L11.6825 2.77906Z"
                              fill="#023047"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_5692_1479">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        Social Media Management
                      </li>
                      <li>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.9987 14.6673C4.3167 14.6673 1.33203 11.6827 1.33203 8.00065C1.33203 4.31865 4.3167 1.33398 7.9987 1.33398C11.6807 1.33398 14.6654 4.31865 14.6654 8.00065C14.6654 11.6827 11.6807 14.6673 7.9987 14.6673ZM8.66536 8.00065V4.66732H7.33203V9.33398H11.332V8.00065H8.66536Z"
                            fill="#023047"
                          />
                        </svg>
                        Product Management
                      </li>
                      <li>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_5692_2007)">
                            <path
                              d="M4.8451 -0.00033861C4.68553 0.0208279 4.54061 0.103672 4.44141 0.230431L2.34479 2.86489L0.960176 1.94182C0.891977 1.89601 0.815405 1.86413 0.734853 1.84799C0.654302 1.83186 0.571357 1.83178 0.490777 1.84778C0.410197 1.86378 0.33357 1.89553 0.265291 1.94121C0.197011 1.98689 0.138425 2.04561 0.0928926 2.11399C0.0473603 2.18237 0.0157785 2.25906 -4.07184e-05 2.33968C-0.0158599 2.42029 -0.0156051 2.50324 0.00070917 2.58375C0.0170234 2.66427 0.0490759 2.74077 0.0950275 2.80887C0.140979 2.87697 0.199925 2.93532 0.268484 2.98058L2.11464 4.21135C2.24403 4.29751 2.40123 4.3315 2.55466 4.3065C2.70809 4.2815 2.84637 4.19936 2.94171 4.07658L5.40325 0.999661C5.48159 0.904103 5.52934 0.787175 5.5403 0.664098C5.55126 0.541022 5.52491 0.417497 5.46469 0.309602C5.40447 0.201708 5.31316 0.114441 5.20265 0.0591607C5.09214 0.0038807 4.96755 -0.016852 4.8451 -0.00033861ZM7.38356 1.84582V3.07658H15.9989V1.84582H7.38356ZM4.8451 5.53812C4.68553 5.55929 4.54061 5.64213 4.44141 5.76889L2.34479 8.40335L0.960176 7.48028C0.822427 7.38847 0.65385 7.35515 0.49153 7.38763C0.32921 7.42012 0.186444 7.51576 0.0946378 7.65351C0.0028321 7.79126 -0.0304928 7.95983 0.00199431 8.12215C0.0344814 8.28447 0.130119 8.42724 0.267869 8.51905L2.11402 9.74982C2.24341 9.83597 2.40062 9.86996 2.55404 9.84496C2.70747 9.81996 2.84575 9.73782 2.9411 9.61505L5.40264 6.53812C5.48091 6.4426 5.52863 6.32574 5.5396 6.20274C5.55057 6.07973 5.52428 5.95627 5.46414 5.84841C5.404 5.74055 5.3128 5.65327 5.2024 5.59794C5.092 5.5426 4.9675 5.52176 4.8451 5.53812ZM7.38356 7.38428V8.61505H15.9989V7.38428H7.38356ZM4.8451 11.0766C4.68553 11.0978 4.54061 11.1806 4.44141 11.3074L2.34479 13.9418L0.960176 13.0187C0.89197 12.9733 0.815477 12.9417 0.735067 12.9258C0.654656 12.9099 0.571902 12.91 0.49153 12.9261C0.32921 12.9586 0.186444 13.0542 0.0946378 13.192C0.0028321 13.3297 -0.0304928 13.4983 0.00199431 13.6606C0.0344814 13.8229 0.130119 13.9657 0.267869 14.0575L2.11402 15.2883C2.24341 15.3744 2.40062 15.4084 2.55404 15.3834C2.70747 15.3584 2.84575 15.2763 2.9411 15.1535L5.40264 12.0766C5.48091 11.9811 5.52863 11.8642 5.5396 11.7412C5.55057 11.6182 5.52428 11.4947 5.46414 11.3869C5.404 11.279 5.3128 11.1917 5.2024 11.1364C5.092 11.0811 4.9675 11.0602 4.8451 11.0766ZM7.38356 12.9227V14.1535H15.9989V12.9227H7.38356Z"
                              fill="#023047"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_5692_2007">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        Virtual Assistant
                      </li>
                      <li>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 0.666016C6.4087 0.666016 4.88258 1.29816 3.75736 2.42338C2.63214 3.54859 2 5.07472 2 6.66602V11.3327C2 12.4393 2.89333 13.3327 4 13.3327H6V7.99935H3.33333V6.66602C3.33333 4.08602 5.42 1.99935 8 1.99935C10.58 1.99935 12.6667 4.08602 12.6667 6.66602V7.99935H10V13.3327H12C13.1067 13.3327 14 12.4393 14 11.3327V6.66602C14 5.07472 13.3679 3.54859 12.2426 2.42338C11.1174 1.29816 9.5913 0.666016 8 0.666016Z"
                            fill="#023047"
                          />
                        </svg>
                        Customer Support
                      </li>
                    </ul>
                  </div>
                </div>

                <div className=" ct_mt_50">
                  <div class="row gx-5">
                    <div class="col-lg-3 mb-4 mb-md-0">
                      <div class="ct_filter_sidebar ct_filter_sidebar_grey ct_custom_scroll">
                        <div class="ct_close_filter d-block d-lg-none">
                          <i class="fa-solid fa-xmark"></i>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <label class="toggle-switch">
                            <input type="checkbox" />
                            <div class="toggle-switch-background">
                              <div class="toggle-switch-handle"></div>
                            </div>
                          </label>
                          Available for work
                        </div>

                        <div class="ct_mt_30">
                          <ul>
                            <li>
                              <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="">Remote</label>
                              </div>
                            </li>
                            <li class="mt-2">
                              <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="">Full-Time</label>
                              </div>
                            </li>
                            <li class="mt-2">
                              <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="">Part-Time</label>
                              </div>
                            </li>
                            <li class="mt-2">
                              <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="">Hybrid</label>
                              </div>
                            </li>
                            <li class="mt-2">
                              <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="">On-Site</label>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div class="ct_mt_30">
                          <h5 class="ct_fs_18  ct_mb_20">Talent Tier</h5>
                          <ul>
                            <li>
                              <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="">
                                  NuGlow{" "}
                                  <img
                                    src="../assets/img/noto_fire_12.png"
                                    className="ct_img_w_16 ms-2"
                                  />
                                </label>
                              </div>
                            </li>
                            <li class="mt-2">
                              <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="">
                                  NuForge{" "}
                                  <img
                                    src="../assets/img/noto-v1_helicopter.png"
                                    className="ct_img_w_16 ms-2"
                                  />
                                </label>
                              </div>
                            </li>
                            <li class="mt-2">
                              <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="">
                                  NuStar{" "}
                                  <img
                                    src="../assets/img/fluent-emoji-flat_small-airplane.png"
                                    className="ct_img_w_16 ms-2"
                                  />{" "}
                                </label>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div class="ct_mt_30">
                          <div class="form-group">
                            <label class="mb-2 ct_fs_18">Skills</label>
                            <div class="ct_search">
                              <input
                                type="text"
                                class="form-control ct_input ct_h_35"
                                placeholder="Search"
                              />
                              <i class="fa-solid fa-magnifying-glass ct_left_icon_search"></i>
                            </div>
                          </div>
                        </div>
                        <div class="ct_mt_30">
                          <div class="form-group">
                            <label class="mb-2 ct_fs_18">Location</label>
                            <div class="ct_search">
                              <input
                                type="text"
                                class="form-control ct_input ct_h_35"
                                placeholder="Search"
                              />
                              <i class="fa-solid fa-magnifying-glass ct_left_icon_search"></i>
                            </div>
                          </div>
                        </div>

                        <div class="ct_mt_30">
                          <h5 class="ct_fs_18  ct_mb_20">Experience Level</h5>
                          <ul>
                            <li>
                              <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="">0-2 years</label>
                              </div>
                            </li>
                            <li class="mt-2">
                              <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="">2-5 years</label>
                              </div>
                            </li>
                            <li class="mt-2">
                              <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="">5-8 years</label>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="ct_mt_30">
                          <div class="form-group">
                            <label class="mb-2 ct_fs_18">Salary Range</label>
                            <div class="range-wrapper">
                              <input
                                type="range"
                                min="0"
                                max="100"
                                value="40"
                                class="range-slider"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-9 ct_ps_lg_80 mb-4 mb-md-0">
                      <div class="ct_filter_btn d-flex d-lg-none justify-content-end mb-4">
                        <button class="ct_outline_grey ct_yellow_btn ct_h_35 d-flex align-items-center gap-2">
                          Filter{" "}
                          <img
                            src="../assets/img/octicon_filter-16.png"
                            alt=""
                          />
                        </button>
                      </div>

                      <div className="row ">
                        <div className="col-lg-12 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="d-flex align-items-center gap-4 justify-content-between ct_flex_col_767">
                                <div className="d-flex align-items-center gap-4 ct_flex_1 ct_flex_col_767 ">
                                  <div className=" ct_flex_shrink_0">
                                    <img
                                      src="../assets/img/user_22.png"
                                      className="ct_img_100"
                                    />
                                  </div>
                                  <div className="">
                                    <div className="ct_flex_1 d-flex align-items-center gap-md-5 gap-3 ct_flex_col_575">
                                      <div>
                                        <p className="ct_fs_16 mb-2 ct_darkblue_text">
                                          Alex Carter
                                        </p>
                                        <h4
                                          className="ct_fs_18 mb-0  ct_darkblue_text ct_overflow_text ct_para_scroll"
                                          style={{ maxHeight: "80px" }}
                                        >
                                          Certified WIX | Full-Stack Developer|
                                          2D Drawings
                                        </h4>
                                      </div>
                                      <div>
                                        <span
                                          className="ct_badge ct_fs_14 ct_white_nowrap ct_darkblue_text ct_h_35 d-flex align-items-center justify-content-center ct_fit_content gap-1 border-0"
                                          style={{
                                            backgroundColor:
                                              "hsl(43deg 100% 51% / 50%)",
                                          }}
                                        >
                                          <img
                                            class="ct_img_w_16 ms-2"
                                            src="../assets/img/noto_fire_12.png"
                                          />{" "}
                                          NuGlow
                                        </span>
                                      </div>
                                    </div>
                                    <p className="d-flex align-items-center gap-2 ct_text_op_6 mb-0 mt-1 ct_fs_16 ct_darkblue_text">
                                      United States
                                    </p>
                                  </div>
                                </div>
                                <div className="pe-xl-5 ct_w_100_767">
                                  <button
                                    data-bs-target="#ct_view_profile_modal"
                                    data-bs-toggle="modal"
                                    // onClick={(e) => {
                                    //   e.preventDefault();
                                    //   openSignUp();
                                    // }}
                                    className="ct_yellow_btn ct_h_40 ct_border_radius_8 border-0 ct_white_nowrap ct_w_100_767"
                                    style={{ backgroundColor: "#FFB703" }}
                                  >
                                    View Profile
                                  </button>
                                </div>
                              </div>
                              <figcaption className="mt-4">
                                <ul className="d-flex align-items-center gap-4 flex-wrap">
                                  <li>$100 / project</li>
                                  <li class="d-flex align-items-center gap-1">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        x="0.5"
                                        y="0.5"
                                        width="23"
                                        height="23"
                                        rx="11.5"
                                        stroke="#219EBC"
                                      />
                                      <path
                                        d="M7.9987 17.3333C7.80981 17.3333 7.65159 17.2693 7.52403 17.1413C7.39648 17.0133 7.33248 16.8551 7.33203 16.6666C7.33159 16.4782 7.39559 16.32 7.52403 16.192C7.65248 16.064 7.8107 16 7.9987 16H15.9987C16.1876 16 16.346 16.064 16.474 16.192C16.602 16.32 16.6658 16.4782 16.6654 16.6666C16.6649 16.8551 16.6009 17.0135 16.4734 17.142C16.3458 17.2704 16.1876 17.3342 15.9987 17.3333H7.9987ZM8.46537 15C8.14314 15 7.85714 14.8944 7.60737 14.6833C7.35759 14.4722 7.2047 14.2055 7.1487 13.8833L6.48203 9.64998C6.45981 9.64998 6.43492 9.65287 6.40737 9.65865C6.37981 9.66443 6.3547 9.66709 6.33203 9.66665C6.05425 9.66665 5.81825 9.56954 5.62403 9.37531C5.42981 9.18109 5.33248 8.94487 5.33203 8.66665C5.33159 8.38843 5.42892 8.15243 5.62403 7.95865C5.81914 7.76487 6.05514 7.66754 6.33203 7.66665C6.60892 7.66576 6.84514 7.76309 7.0407 7.95865C7.23626 8.1542 7.33337 8.3902 7.33203 8.66665C7.33203 8.74443 7.32359 8.81665 7.3067 8.88331C7.28981 8.94998 7.27048 9.01109 7.2487 9.06665L9.33203 9.99998L11.4154 7.14998C11.2931 7.06109 11.1931 6.94443 11.1154 6.79998C11.0376 6.65554 10.9987 6.49998 10.9987 6.33331C10.9987 6.05554 11.096 5.81931 11.2907 5.62465C11.4854 5.42998 11.7214 5.33287 11.9987 5.33331C12.276 5.33376 12.5123 5.43109 12.7074 5.62531C12.9025 5.81954 12.9996 6.05554 12.9987 6.33331C12.9987 6.49998 12.9598 6.65554 12.882 6.79998C12.8043 6.94443 12.7043 7.06109 12.582 7.14998L14.6654 9.99998L16.7487 9.06665C16.7265 9.01109 16.7069 8.94998 16.69 8.88331C16.6731 8.81665 16.6649 8.74443 16.6654 8.66665C16.6654 8.38887 16.7627 8.15265 16.9574 7.95798C17.152 7.76331 17.388 7.6662 17.6654 7.66665C17.9427 7.66709 18.1789 7.76443 18.374 7.95865C18.5691 8.15287 18.6663 8.38887 18.6654 8.66665C18.6645 8.94443 18.5674 9.18065 18.374 9.37531C18.1807 9.56998 17.9445 9.66709 17.6654 9.66665C17.6431 9.66665 17.6183 9.66398 17.5907 9.65865C17.5631 9.65331 17.538 9.65043 17.5154 9.64998L16.8487 13.8833C16.7931 14.2055 16.6405 14.4722 16.3907 14.6833C16.1409 14.8944 15.8547 15 15.532 15H8.46537Z"
                                        fill="#219EBC"
                                      />
                                    </svg>
                                    <span>100% Job Success</span>
                                  </li>
                                  <li>5+ years experience</li>
                                  <li>
                                    <button
                                      className="ct_badge border-0 gap-1"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                      }}
                                    >
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M2.82402 8.32107L8.27042 0.893869C8.39214 0.728109 8.56802 0.610152 8.76757 0.560436C8.96713 0.510719 9.17778 0.532376 9.36305 0.621652C9.54831 0.710929 9.69651 0.862202 9.78197 1.04926C9.86742 1.23632 9.88475 1.44738 9.83095 1.64587L8.62668 6.06294C8.61586 6.10249 8.6143 6.14401 8.62213 6.18427C8.62997 6.22453 8.64698 6.26244 8.67185 6.29505C8.69672 6.32766 8.72878 6.35409 8.76553 6.3723C8.80228 6.3905 8.84274 6.39998 8.88375 6.4H12.5317C12.6803 6.39994 12.8259 6.44108 12.9525 6.51883C13.0791 6.59658 13.1816 6.7079 13.2487 6.84042C13.3158 6.97294 13.3448 7.12147 13.3325 7.2695C13.3203 7.41753 13.2672 7.55926 13.1792 7.67894L7.73282 15.1072C7.61111 15.2732 7.4351 15.3914 7.23534 15.4412C7.03558 15.491 6.82469 15.4693 6.63928 15.3798C6.45387 15.2904 6.30564 15.1388 6.22034 14.9514C6.13503 14.7641 6.11803 14.5527 6.17228 14.3541L7.37655 9.93707C7.38738 9.89751 7.38893 9.85599 7.3811 9.81573C7.37327 9.77547 7.35625 9.73757 7.33138 9.70496C7.30651 9.67235 7.27445 9.64591 7.2377 9.62771C7.20095 9.6095 7.16049 9.60002 7.11948 9.6H3.47148C3.32295 9.60006 3.1773 9.55893 3.05074 9.48118C2.92418 9.40343 2.82166 9.29211 2.75457 9.15958C2.68748 9.02706 2.65845 8.87854 2.67071 8.73051C2.68297 8.58248 2.73604 8.44075 2.82402 8.32107Z"
                                          fill="#219EBC"
                                        />
                                      </svg>
                                      <span className="ct_darksky_blue_text ct_fs_12">
                                        Available now
                                      </span>
                                    </button>
                                  </li>
                                </ul>
                                <ul className="d-flex align-items-center gap-4 ct_mt_20 flex-wrap">
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M7.33203 10H8.66536V11.3334H7.33203V10ZM7.33203 4.66669H8.66536V8.66669H7.33203V4.66669Z"
                                          fill="#023047"
                                        />
                                        <path
                                          d="M3.33984 0.666687V15.3334H12.6665V0.666687H3.33984ZM11.3332 12H4.66651V4.00002H11.3332V12Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        Node.js
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M14.0013 1.336H2.0013C1.648 1.33705 1.30948 1.47787 1.05966 1.72769C0.809839 1.97751 0.669024 2.31603 0.667969 2.66933V10.6693C0.669024 11.0226 0.809839 11.3612 1.05966 11.611C1.30948 11.8608 1.648 12.0016 2.0013 12.0027H6.66797V13.336H5.33464V14.6693H10.668V13.336H9.33464V12.0027H14.0013C14.3546 12.0016 14.6931 11.8608 14.9429 11.611C15.1928 11.3612 15.3336 11.0226 15.3346 10.6693V2.66933C15.3336 2.31603 15.1928 1.97751 14.9429 1.72769C14.6931 1.47787 14.3546 1.33705 14.0013 1.336ZM7.1693 9.11333L4.00264 5.94667L4.9453 5.00467L7.1693 7.22867L11.0593 3.338L12.0026 4.28133L7.1693 9.11333Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        PostgreSQL
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M13.6667 2.33333H3C2.82319 2.33333 2.65362 2.40357 2.5286 2.5286C2.40357 2.65362 2.33333 2.82319 2.33333 3V12.3333C2.33333 12.5101 2.40357 12.6797 2.5286 12.8047C2.65362 12.9298 2.82319 13 3 13H13.6667C13.8435 13 14.013 12.9298 14.1381 12.8047C14.2631 12.6797 14.3333 12.5101 14.3333 12.3333V3C14.3333 2.82319 14.2631 2.65362 14.1381 2.5286C14.013 2.40357 13.8435 2.33333 13.6667 2.33333ZM3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V12.3333C1 12.8638 1.21071 13.3725 1.58579 13.7475C1.96086 14.1226 2.46957 14.3333 3 14.3333H13.6667C14.1971 14.3333 14.7058 14.1226 15.0809 13.7475C15.456 13.3725 15.6667 12.8638 15.6667 12.3333V3C15.6667 2.46957 15.456 1.96086 15.0809 1.58579C14.7058 1.21071 14.1971 1 13.6667 1H3ZM4.33333 4.33333H5.66667V5.66667H4.33333V4.33333ZM7.66667 4.33333C7.48986 4.33333 7.32029 4.40357 7.19526 4.5286C7.07024 4.65362 7 4.82319 7 5C7 5.17681 7.07024 5.34638 7.19526 5.4714C7.32029 5.59643 7.48986 5.66667 7.66667 5.66667H11.6667C11.8435 5.66667 12.013 5.59643 12.1381 5.4714C12.2631 5.34638 12.3333 5.17681 12.3333 5C12.3333 4.82319 12.2631 4.65362 12.1381 4.5286C12.013 4.40357 11.8435 4.33333 11.6667 4.33333H7.66667ZM5.66667 7H4.33333V8.33333H5.66667V7ZM7 7.66667C7 7.48986 7.07024 7.32029 7.19526 7.19526C7.32029 7.07024 7.48986 7 7.66667 7H11.6667C11.8435 7 12.013 7.07024 12.1381 7.19526C12.2631 7.32029 12.3333 7.48986 12.3333 7.66667C12.3333 7.84348 12.2631 8.01305 12.1381 8.13807C12.013 8.26309 11.8435 8.33333 11.6667 8.33333H7.66667C7.48986 8.33333 7.32029 8.26309 7.19526 8.13807C7.07024 8.01305 7 7.84348 7 7.66667ZM5.66667 9.66667H4.33333V11H5.66667V9.66667ZM7 10.3333C7 10.1565 7.07024 9.98695 7.19526 9.86193C7.32029 9.7369 7.48986 9.66667 7.66667 9.66667H11.6667C11.8435 9.66667 12.013 9.7369 12.1381 9.86193C12.2631 9.98695 12.3333 10.1565 12.3333 10.3333C12.3333 10.5101 12.2631 10.6797 12.1381 10.8047C12.013 10.9298 11.8435 11 11.6667 11H7.66667C7.48986 11 7.32029 10.9298 7.19526 10.8047C7.07024 10.6797 7 10.5101 7 10.3333Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        Java Script
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M7.33203 10H8.66536V11.3334H7.33203V10ZM7.33203 4.66669H8.66536V8.66669H7.33203V4.66669Z"
                                          fill="#023047"
                                        />
                                        <path
                                          d="M3.33984 0.666687V15.3334H12.6665V0.666687H3.33984ZM11.3332 12H4.66651V4.00002H11.3332V12Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        React
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M13.6667 2.33333H3C2.82319 2.33333 2.65362 2.40357 2.5286 2.5286C2.40357 2.65362 2.33333 2.82319 2.33333 3V12.3333C2.33333 12.5101 2.40357 12.6797 2.5286 12.8047C2.65362 12.9298 2.82319 13 3 13H13.6667C13.8435 13 14.013 12.9298 14.1381 12.8047C14.2631 12.6797 14.3333 12.5101 14.3333 12.3333V3C14.3333 2.82319 14.2631 2.65362 14.1381 2.5286C14.013 2.40357 13.8435 2.33333 13.6667 2.33333ZM3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V12.3333C1 12.8638 1.21071 13.3725 1.58579 13.7475C1.96086 14.1226 2.46957 14.3333 3 14.3333H13.6667C14.1971 14.3333 14.7058 14.1226 15.0809 13.7475C15.456 13.3725 15.6667 12.8638 15.6667 12.3333V3C15.6667 2.46957 15.456 1.96086 15.0809 1.58579C14.7058 1.21071 14.1971 1 13.6667 1H3ZM4.33333 4.33333H5.66667V5.66667H4.33333V4.33333ZM7.66667 4.33333C7.48986 4.33333 7.32029 4.40357 7.19526 4.5286C7.07024 4.65362 7 4.82319 7 5C7 5.17681 7.07024 5.34638 7.19526 5.4714C7.32029 5.59643 7.48986 5.66667 7.66667 5.66667H11.6667C11.8435 5.66667 12.013 5.59643 12.1381 5.4714C12.2631 5.34638 12.3333 5.17681 12.3333 5C12.3333 4.82319 12.2631 4.65362 12.1381 4.5286C12.013 4.40357 11.8435 4.33333 11.6667 4.33333H7.66667ZM5.66667 7H4.33333V8.33333H5.66667V7ZM7 7.66667C7 7.48986 7.07024 7.32029 7.19526 7.19526C7.32029 7.07024 7.48986 7 7.66667 7H11.6667C11.8435 7 12.013 7.07024 12.1381 7.19526C12.2631 7.32029 12.3333 7.48986 12.3333 7.66667C12.3333 7.84348 12.2631 8.01305 12.1381 8.13807C12.013 8.26309 11.8435 8.33333 11.6667 8.33333H7.66667C7.48986 8.33333 7.32029 8.26309 7.19526 8.13807C7.07024 8.01305 7 7.84348 7 7.66667ZM5.66667 9.66667H4.33333V11H5.66667V9.66667ZM7 10.3333C7 10.1565 7.07024 9.98695 7.19526 9.86193C7.32029 9.7369 7.48986 9.66667 7.66667 9.66667H11.6667C11.8435 9.66667 12.013 9.7369 12.1381 9.86193C12.2631 9.98695 12.3333 10.1565 12.3333 10.3333C12.3333 10.5101 12.2631 10.6797 12.1381 10.8047C12.013 10.9298 11.8435 11 11.6667 11H7.66667C7.48986 11 7.32029 10.9298 7.19526 10.8047C7.07024 10.6797 7 10.5101 7 10.3333Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        Java Script
                                      </span>
                                    </button>
                                  </li>
                                </ul>

                                <p className="ct_para_scroll ct_custom_scroll ct_fS_16 ct_darkblue_text mt-4 mb-0">
                                  I specialize in both front-end and back-end
                                  development, and I’m passionate about solving
                                  complex problems and creating seamless,
                                  user-friendly solutions.
                                </p>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-12 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="d-flex align-items-center gap-4 justify-content-between ct_flex_col_767">
                                <div className="d-flex align-items-center gap-4 ct_flex_1 ct_flex_col_767 ">
                                  <div className=" ct_flex_shrink_0">
                                    <img
                                      src="../assets/img/user_22.png"
                                      className="ct_img_100"
                                    />
                                  </div>
                                  <div className="">
                                    <div className="ct_flex_1 d-flex align-items-center gap-md-5 gap-3 ct_flex_col_575">
                                      <div>
                                        <p className="ct_fs_16 mb-2 ct_darkblue_text">
                                          Alex Carter
                                        </p>
                                        <h4
                                          className="ct_fs_18 mb-0  ct_darkblue_text ct_overflow_text ct_para_scroll"
                                          style={{ maxHeight: "80px" }}
                                        >
                                          Certified WIX | Full-Stack Developer|
                                          2D Drawings
                                        </h4>
                                      </div>
                                      <div>
                                        <span
                                          className="ct_badge ct_fs_14 ct_white_nowrap ct_darkblue_text ct_h_35 d-flex align-items-center justify-content-center ct_fit_content gap-1 border-0"
                                          style={{
                                            backgroundColor:
                                              "hsl(32deg 100% 49% / 30%)",
                                          }}
                                        >
                                          <img
                                            class="ct_img_w_16 ms-2"
                                            src="../assets/img/noto_fire_12.png"
                                          />{" "}
                                          NuForge
                                        </span>
                                      </div>
                                    </div>
                                    <p className="d-flex align-items-center gap-2 ct_text_op_6 mb-0 mt-1 ct_fs_16 ct_darkblue_text">
                                      United States
                                    </p>
                                  </div>
                                </div>
                                <div className="pe-xl-5 ct_w_100_767">
                                  <button
                                    // data-bs-target="#ct_view_profile_modal"
                                    // data-bs-toggle="modal"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      openSignUp();
                                    }}
                                    className="ct_yellow_btn ct_h_40 ct_border_radius_8 border-0 ct_white_nowrap ct_w_100_767"
                                    style={{ backgroundColor: "#FFB703" }}
                                  >
                                    View Profile
                                  </button>
                                </div>
                              </div>
                              <figcaption className="mt-4">
                                <ul className="d-flex align-items-center gap-4 flex-wrap">
                                  <li>$100 / project</li>
                                  <li class="d-flex align-items-center gap-1">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        x="0.5"
                                        y="0.5"
                                        width="23"
                                        height="23"
                                        rx="11.5"
                                        stroke="#219EBC"
                                      />
                                      <path
                                        d="M7.9987 17.3333C7.80981 17.3333 7.65159 17.2693 7.52403 17.1413C7.39648 17.0133 7.33248 16.8551 7.33203 16.6666C7.33159 16.4782 7.39559 16.32 7.52403 16.192C7.65248 16.064 7.8107 16 7.9987 16H15.9987C16.1876 16 16.346 16.064 16.474 16.192C16.602 16.32 16.6658 16.4782 16.6654 16.6666C16.6649 16.8551 16.6009 17.0135 16.4734 17.142C16.3458 17.2704 16.1876 17.3342 15.9987 17.3333H7.9987ZM8.46537 15C8.14314 15 7.85714 14.8944 7.60737 14.6833C7.35759 14.4722 7.2047 14.2055 7.1487 13.8833L6.48203 9.64998C6.45981 9.64998 6.43492 9.65287 6.40737 9.65865C6.37981 9.66443 6.3547 9.66709 6.33203 9.66665C6.05425 9.66665 5.81825 9.56954 5.62403 9.37531C5.42981 9.18109 5.33248 8.94487 5.33203 8.66665C5.33159 8.38843 5.42892 8.15243 5.62403 7.95865C5.81914 7.76487 6.05514 7.66754 6.33203 7.66665C6.60892 7.66576 6.84514 7.76309 7.0407 7.95865C7.23626 8.1542 7.33337 8.3902 7.33203 8.66665C7.33203 8.74443 7.32359 8.81665 7.3067 8.88331C7.28981 8.94998 7.27048 9.01109 7.2487 9.06665L9.33203 9.99998L11.4154 7.14998C11.2931 7.06109 11.1931 6.94443 11.1154 6.79998C11.0376 6.65554 10.9987 6.49998 10.9987 6.33331C10.9987 6.05554 11.096 5.81931 11.2907 5.62465C11.4854 5.42998 11.7214 5.33287 11.9987 5.33331C12.276 5.33376 12.5123 5.43109 12.7074 5.62531C12.9025 5.81954 12.9996 6.05554 12.9987 6.33331C12.9987 6.49998 12.9598 6.65554 12.882 6.79998C12.8043 6.94443 12.7043 7.06109 12.582 7.14998L14.6654 9.99998L16.7487 9.06665C16.7265 9.01109 16.7069 8.94998 16.69 8.88331C16.6731 8.81665 16.6649 8.74443 16.6654 8.66665C16.6654 8.38887 16.7627 8.15265 16.9574 7.95798C17.152 7.76331 17.388 7.6662 17.6654 7.66665C17.9427 7.66709 18.1789 7.76443 18.374 7.95865C18.5691 8.15287 18.6663 8.38887 18.6654 8.66665C18.6645 8.94443 18.5674 9.18065 18.374 9.37531C18.1807 9.56998 17.9445 9.66709 17.6654 9.66665C17.6431 9.66665 17.6183 9.66398 17.5907 9.65865C17.5631 9.65331 17.538 9.65043 17.5154 9.64998L16.8487 13.8833C16.7931 14.2055 16.6405 14.4722 16.3907 14.6833C16.1409 14.8944 15.8547 15 15.532 15H8.46537Z"
                                        fill="#219EBC"
                                      />
                                    </svg>
                                    <span>100% Job Success</span>
                                  </li>
                                  <li>5+ years experience</li>
                                  <li>
                                    <button
                                      className="ct_badge border-0 gap-1"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                      }}
                                    >
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M2.82402 8.32107L8.27042 0.893869C8.39214 0.728109 8.56802 0.610152 8.76757 0.560436C8.96713 0.510719 9.17778 0.532376 9.36305 0.621652C9.54831 0.710929 9.69651 0.862202 9.78197 1.04926C9.86742 1.23632 9.88475 1.44738 9.83095 1.64587L8.62668 6.06294C8.61586 6.10249 8.6143 6.14401 8.62213 6.18427C8.62997 6.22453 8.64698 6.26244 8.67185 6.29505C8.69672 6.32766 8.72878 6.35409 8.76553 6.3723C8.80228 6.3905 8.84274 6.39998 8.88375 6.4H12.5317C12.6803 6.39994 12.8259 6.44108 12.9525 6.51883C13.0791 6.59658 13.1816 6.7079 13.2487 6.84042C13.3158 6.97294 13.3448 7.12147 13.3325 7.2695C13.3203 7.41753 13.2672 7.55926 13.1792 7.67894L7.73282 15.1072C7.61111 15.2732 7.4351 15.3914 7.23534 15.4412C7.03558 15.491 6.82469 15.4693 6.63928 15.3798C6.45387 15.2904 6.30564 15.1388 6.22034 14.9514C6.13503 14.7641 6.11803 14.5527 6.17228 14.3541L7.37655 9.93707C7.38738 9.89751 7.38893 9.85599 7.3811 9.81573C7.37327 9.77547 7.35625 9.73757 7.33138 9.70496C7.30651 9.67235 7.27445 9.64591 7.2377 9.62771C7.20095 9.6095 7.16049 9.60002 7.11948 9.6H3.47148C3.32295 9.60006 3.1773 9.55893 3.05074 9.48118C2.92418 9.40343 2.82166 9.29211 2.75457 9.15958C2.68748 9.02706 2.65845 8.87854 2.67071 8.73051C2.68297 8.58248 2.73604 8.44075 2.82402 8.32107Z"
                                          fill="#219EBC"
                                        />
                                      </svg>
                                      <span className="ct_darksky_blue_text ct_fs_12">
                                        Available now
                                      </span>
                                    </button>
                                  </li>
                                </ul>
                                <ul className="d-flex align-items-center gap-4 ct_mt_20 flex-wrap">
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M7.33203 10H8.66536V11.3334H7.33203V10ZM7.33203 4.66669H8.66536V8.66669H7.33203V4.66669Z"
                                          fill="#023047"
                                        />
                                        <path
                                          d="M3.33984 0.666687V15.3334H12.6665V0.666687H3.33984ZM11.3332 12H4.66651V4.00002H11.3332V12Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        Node.js
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M14.0013 1.336H2.0013C1.648 1.33705 1.30948 1.47787 1.05966 1.72769C0.809839 1.97751 0.669024 2.31603 0.667969 2.66933V10.6693C0.669024 11.0226 0.809839 11.3612 1.05966 11.611C1.30948 11.8608 1.648 12.0016 2.0013 12.0027H6.66797V13.336H5.33464V14.6693H10.668V13.336H9.33464V12.0027H14.0013C14.3546 12.0016 14.6931 11.8608 14.9429 11.611C15.1928 11.3612 15.3336 11.0226 15.3346 10.6693V2.66933C15.3336 2.31603 15.1928 1.97751 14.9429 1.72769C14.6931 1.47787 14.3546 1.33705 14.0013 1.336ZM7.1693 9.11333L4.00264 5.94667L4.9453 5.00467L7.1693 7.22867L11.0593 3.338L12.0026 4.28133L7.1693 9.11333Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        PostgreSQL
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M13.6667 2.33333H3C2.82319 2.33333 2.65362 2.40357 2.5286 2.5286C2.40357 2.65362 2.33333 2.82319 2.33333 3V12.3333C2.33333 12.5101 2.40357 12.6797 2.5286 12.8047C2.65362 12.9298 2.82319 13 3 13H13.6667C13.8435 13 14.013 12.9298 14.1381 12.8047C14.2631 12.6797 14.3333 12.5101 14.3333 12.3333V3C14.3333 2.82319 14.2631 2.65362 14.1381 2.5286C14.013 2.40357 13.8435 2.33333 13.6667 2.33333ZM3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V12.3333C1 12.8638 1.21071 13.3725 1.58579 13.7475C1.96086 14.1226 2.46957 14.3333 3 14.3333H13.6667C14.1971 14.3333 14.7058 14.1226 15.0809 13.7475C15.456 13.3725 15.6667 12.8638 15.6667 12.3333V3C15.6667 2.46957 15.456 1.96086 15.0809 1.58579C14.7058 1.21071 14.1971 1 13.6667 1H3ZM4.33333 4.33333H5.66667V5.66667H4.33333V4.33333ZM7.66667 4.33333C7.48986 4.33333 7.32029 4.40357 7.19526 4.5286C7.07024 4.65362 7 4.82319 7 5C7 5.17681 7.07024 5.34638 7.19526 5.4714C7.32029 5.59643 7.48986 5.66667 7.66667 5.66667H11.6667C11.8435 5.66667 12.013 5.59643 12.1381 5.4714C12.2631 5.34638 12.3333 5.17681 12.3333 5C12.3333 4.82319 12.2631 4.65362 12.1381 4.5286C12.013 4.40357 11.8435 4.33333 11.6667 4.33333H7.66667ZM5.66667 7H4.33333V8.33333H5.66667V7ZM7 7.66667C7 7.48986 7.07024 7.32029 7.19526 7.19526C7.32029 7.07024 7.48986 7 7.66667 7H11.6667C11.8435 7 12.013 7.07024 12.1381 7.19526C12.2631 7.32029 12.3333 7.48986 12.3333 7.66667C12.3333 7.84348 12.2631 8.01305 12.1381 8.13807C12.013 8.26309 11.8435 8.33333 11.6667 8.33333H7.66667C7.48986 8.33333 7.32029 8.26309 7.19526 8.13807C7.07024 8.01305 7 7.84348 7 7.66667ZM5.66667 9.66667H4.33333V11H5.66667V9.66667ZM7 10.3333C7 10.1565 7.07024 9.98695 7.19526 9.86193C7.32029 9.7369 7.48986 9.66667 7.66667 9.66667H11.6667C11.8435 9.66667 12.013 9.7369 12.1381 9.86193C12.2631 9.98695 12.3333 10.1565 12.3333 10.3333C12.3333 10.5101 12.2631 10.6797 12.1381 10.8047C12.013 10.9298 11.8435 11 11.6667 11H7.66667C7.48986 11 7.32029 10.9298 7.19526 10.8047C7.07024 10.6797 7 10.5101 7 10.3333Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        Java Script
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M7.33203 10H8.66536V11.3334H7.33203V10ZM7.33203 4.66669H8.66536V8.66669H7.33203V4.66669Z"
                                          fill="#023047"
                                        />
                                        <path
                                          d="M3.33984 0.666687V15.3334H12.6665V0.666687H3.33984ZM11.3332 12H4.66651V4.00002H11.3332V12Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        React
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M13.6667 2.33333H3C2.82319 2.33333 2.65362 2.40357 2.5286 2.5286C2.40357 2.65362 2.33333 2.82319 2.33333 3V12.3333C2.33333 12.5101 2.40357 12.6797 2.5286 12.8047C2.65362 12.9298 2.82319 13 3 13H13.6667C13.8435 13 14.013 12.9298 14.1381 12.8047C14.2631 12.6797 14.3333 12.5101 14.3333 12.3333V3C14.3333 2.82319 14.2631 2.65362 14.1381 2.5286C14.013 2.40357 13.8435 2.33333 13.6667 2.33333ZM3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V12.3333C1 12.8638 1.21071 13.3725 1.58579 13.7475C1.96086 14.1226 2.46957 14.3333 3 14.3333H13.6667C14.1971 14.3333 14.7058 14.1226 15.0809 13.7475C15.456 13.3725 15.6667 12.8638 15.6667 12.3333V3C15.6667 2.46957 15.456 1.96086 15.0809 1.58579C14.7058 1.21071 14.1971 1 13.6667 1H3ZM4.33333 4.33333H5.66667V5.66667H4.33333V4.33333ZM7.66667 4.33333C7.48986 4.33333 7.32029 4.40357 7.19526 4.5286C7.07024 4.65362 7 4.82319 7 5C7 5.17681 7.07024 5.34638 7.19526 5.4714C7.32029 5.59643 7.48986 5.66667 7.66667 5.66667H11.6667C11.8435 5.66667 12.013 5.59643 12.1381 5.4714C12.2631 5.34638 12.3333 5.17681 12.3333 5C12.3333 4.82319 12.2631 4.65362 12.1381 4.5286C12.013 4.40357 11.8435 4.33333 11.6667 4.33333H7.66667ZM5.66667 7H4.33333V8.33333H5.66667V7ZM7 7.66667C7 7.48986 7.07024 7.32029 7.19526 7.19526C7.32029 7.07024 7.48986 7 7.66667 7H11.6667C11.8435 7 12.013 7.07024 12.1381 7.19526C12.2631 7.32029 12.3333 7.48986 12.3333 7.66667C12.3333 7.84348 12.2631 8.01305 12.1381 8.13807C12.013 8.26309 11.8435 8.33333 11.6667 8.33333H7.66667C7.48986 8.33333 7.32029 8.26309 7.19526 8.13807C7.07024 8.01305 7 7.84348 7 7.66667ZM5.66667 9.66667H4.33333V11H5.66667V9.66667ZM7 10.3333C7 10.1565 7.07024 9.98695 7.19526 9.86193C7.32029 9.7369 7.48986 9.66667 7.66667 9.66667H11.6667C11.8435 9.66667 12.013 9.7369 12.1381 9.86193C12.2631 9.98695 12.3333 10.1565 12.3333 10.3333C12.3333 10.5101 12.2631 10.6797 12.1381 10.8047C12.013 10.9298 11.8435 11 11.6667 11H7.66667C7.48986 11 7.32029 10.9298 7.19526 10.8047C7.07024 10.6797 7 10.5101 7 10.3333Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        Java Script
                                      </span>
                                    </button>
                                  </li>
                                </ul>

                                <p className="ct_para_scroll ct_custom_scroll ct_fS_16 ct_darkblue_text mt-4 mb-0">
                                  I specialize in both front-end and back-end
                                  development, and I’m passionate about solving
                                  complex problems and creating seamless,
                                  user-friendly solutions.
                                </p>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-12 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="d-flex align-items-center gap-4 justify-content-between ct_flex_col_767">
                                <div className="d-flex align-items-center gap-4 ct_flex_1 ct_flex_col_767 ">
                                  <div className=" ct_flex_shrink_0">
                                    <img
                                      src="../assets/img/user_22.png"
                                      className="ct_img_100"
                                    />
                                  </div>
                                  <div className="">
                                    <div className="ct_flex_1 d-flex align-items-center gap-md-5 gap-3 ct_flex_col_575">
                                      <div>
                                        <p className="ct_fs_16 mb-2 ct_darkblue_text">
                                          Alex Carter
                                        </p>
                                        <h4
                                          className="ct_fs_18 mb-0  ct_darkblue_text ct_overflow_text ct_para_scroll"
                                          style={{ maxHeight: "80px" }}
                                        >
                                          Certified WIX | Full-Stack Developer|
                                          2D Drawings
                                        </h4>
                                      </div>
                                      <div>
                                        <span
                                          className="ct_badge ct_fs_14 ct_white_nowrap ct_darkblue_text ct_h_35 d-flex align-items-center justify-content-center ct_fit_content gap-1 border-0"
                                          style={{
                                            backgroundColor:
                                              "hsl(199deg 64% 73% / 50%)",
                                          }}
                                        >
                                          <img
                                            class="ct_img_w_16 ms-2"
                                            src="../assets/img/fluent-emoji-flat_small-airplane.png"
                                          />{" "}
                                          NuStar
                                        </span>
                                      </div>
                                    </div>
                                    <p className="d-flex align-items-center gap-2 ct_text_op_6 mb-0 mt-1 ct_fs_16 ct_darkblue_text">
                                      United States
                                    </p>
                                  </div>
                                </div>
                                <div className="pe-xl-5 ct_w_100_767">
                                  <button
                                    // data-bs-target="#ct_view_profile_modal"
                                    // data-bs-toggle="modal"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      openSignUp();
                                    }}
                                    className="ct_yellow_btn ct_h_40 ct_border_radius_8 border-0 ct_white_nowrap ct_w_100_767"
                                    style={{ backgroundColor: "#FFB703" }}
                                  >
                                    View Profile
                                  </button>
                                </div>
                              </div>
                              <figcaption className="mt-4">
                                <ul className="d-flex align-items-center gap-4 flex-wrap">
                                  <li>$100 / project</li>
                                  <li class="d-flex align-items-center gap-1">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        x="0.5"
                                        y="0.5"
                                        width="23"
                                        height="23"
                                        rx="11.5"
                                        stroke="#219EBC"
                                      />
                                      <path
                                        d="M7.9987 17.3333C7.80981 17.3333 7.65159 17.2693 7.52403 17.1413C7.39648 17.0133 7.33248 16.8551 7.33203 16.6666C7.33159 16.4782 7.39559 16.32 7.52403 16.192C7.65248 16.064 7.8107 16 7.9987 16H15.9987C16.1876 16 16.346 16.064 16.474 16.192C16.602 16.32 16.6658 16.4782 16.6654 16.6666C16.6649 16.8551 16.6009 17.0135 16.4734 17.142C16.3458 17.2704 16.1876 17.3342 15.9987 17.3333H7.9987ZM8.46537 15C8.14314 15 7.85714 14.8944 7.60737 14.6833C7.35759 14.4722 7.2047 14.2055 7.1487 13.8833L6.48203 9.64998C6.45981 9.64998 6.43492 9.65287 6.40737 9.65865C6.37981 9.66443 6.3547 9.66709 6.33203 9.66665C6.05425 9.66665 5.81825 9.56954 5.62403 9.37531C5.42981 9.18109 5.33248 8.94487 5.33203 8.66665C5.33159 8.38843 5.42892 8.15243 5.62403 7.95865C5.81914 7.76487 6.05514 7.66754 6.33203 7.66665C6.60892 7.66576 6.84514 7.76309 7.0407 7.95865C7.23626 8.1542 7.33337 8.3902 7.33203 8.66665C7.33203 8.74443 7.32359 8.81665 7.3067 8.88331C7.28981 8.94998 7.27048 9.01109 7.2487 9.06665L9.33203 9.99998L11.4154 7.14998C11.2931 7.06109 11.1931 6.94443 11.1154 6.79998C11.0376 6.65554 10.9987 6.49998 10.9987 6.33331C10.9987 6.05554 11.096 5.81931 11.2907 5.62465C11.4854 5.42998 11.7214 5.33287 11.9987 5.33331C12.276 5.33376 12.5123 5.43109 12.7074 5.62531C12.9025 5.81954 12.9996 6.05554 12.9987 6.33331C12.9987 6.49998 12.9598 6.65554 12.882 6.79998C12.8043 6.94443 12.7043 7.06109 12.582 7.14998L14.6654 9.99998L16.7487 9.06665C16.7265 9.01109 16.7069 8.94998 16.69 8.88331C16.6731 8.81665 16.6649 8.74443 16.6654 8.66665C16.6654 8.38887 16.7627 8.15265 16.9574 7.95798C17.152 7.76331 17.388 7.6662 17.6654 7.66665C17.9427 7.66709 18.1789 7.76443 18.374 7.95865C18.5691 8.15287 18.6663 8.38887 18.6654 8.66665C18.6645 8.94443 18.5674 9.18065 18.374 9.37531C18.1807 9.56998 17.9445 9.66709 17.6654 9.66665C17.6431 9.66665 17.6183 9.66398 17.5907 9.65865C17.5631 9.65331 17.538 9.65043 17.5154 9.64998L16.8487 13.8833C16.7931 14.2055 16.6405 14.4722 16.3907 14.6833C16.1409 14.8944 15.8547 15 15.532 15H8.46537Z"
                                        fill="#219EBC"
                                      />
                                    </svg>
                                    <span>100% Job Success</span>
                                  </li>
                                  <li>5+ years experience</li>
                                  <li>
                                    <button
                                      className="ct_badge border-0 gap-1"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                      }}
                                    >
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M2.82402 8.32107L8.27042 0.893869C8.39214 0.728109 8.56802 0.610152 8.76757 0.560436C8.96713 0.510719 9.17778 0.532376 9.36305 0.621652C9.54831 0.710929 9.69651 0.862202 9.78197 1.04926C9.86742 1.23632 9.88475 1.44738 9.83095 1.64587L8.62668 6.06294C8.61586 6.10249 8.6143 6.14401 8.62213 6.18427C8.62997 6.22453 8.64698 6.26244 8.67185 6.29505C8.69672 6.32766 8.72878 6.35409 8.76553 6.3723C8.80228 6.3905 8.84274 6.39998 8.88375 6.4H12.5317C12.6803 6.39994 12.8259 6.44108 12.9525 6.51883C13.0791 6.59658 13.1816 6.7079 13.2487 6.84042C13.3158 6.97294 13.3448 7.12147 13.3325 7.2695C13.3203 7.41753 13.2672 7.55926 13.1792 7.67894L7.73282 15.1072C7.61111 15.2732 7.4351 15.3914 7.23534 15.4412C7.03558 15.491 6.82469 15.4693 6.63928 15.3798C6.45387 15.2904 6.30564 15.1388 6.22034 14.9514C6.13503 14.7641 6.11803 14.5527 6.17228 14.3541L7.37655 9.93707C7.38738 9.89751 7.38893 9.85599 7.3811 9.81573C7.37327 9.77547 7.35625 9.73757 7.33138 9.70496C7.30651 9.67235 7.27445 9.64591 7.2377 9.62771C7.20095 9.6095 7.16049 9.60002 7.11948 9.6H3.47148C3.32295 9.60006 3.1773 9.55893 3.05074 9.48118C2.92418 9.40343 2.82166 9.29211 2.75457 9.15958C2.68748 9.02706 2.65845 8.87854 2.67071 8.73051C2.68297 8.58248 2.73604 8.44075 2.82402 8.32107Z"
                                          fill="#219EBC"
                                        />
                                      </svg>
                                      <span className="ct_darksky_blue_text ct_fs_12">
                                        Available now
                                      </span>
                                    </button>
                                  </li>
                                </ul>
                                <ul className="d-flex align-items-center gap-4 ct_mt_20 flex-wrap">
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M7.33203 10H8.66536V11.3334H7.33203V10ZM7.33203 4.66669H8.66536V8.66669H7.33203V4.66669Z"
                                          fill="#023047"
                                        />
                                        <path
                                          d="M3.33984 0.666687V15.3334H12.6665V0.666687H3.33984ZM11.3332 12H4.66651V4.00002H11.3332V12Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        Node.js
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M14.0013 1.336H2.0013C1.648 1.33705 1.30948 1.47787 1.05966 1.72769C0.809839 1.97751 0.669024 2.31603 0.667969 2.66933V10.6693C0.669024 11.0226 0.809839 11.3612 1.05966 11.611C1.30948 11.8608 1.648 12.0016 2.0013 12.0027H6.66797V13.336H5.33464V14.6693H10.668V13.336H9.33464V12.0027H14.0013C14.3546 12.0016 14.6931 11.8608 14.9429 11.611C15.1928 11.3612 15.3336 11.0226 15.3346 10.6693V2.66933C15.3336 2.31603 15.1928 1.97751 14.9429 1.72769C14.6931 1.47787 14.3546 1.33705 14.0013 1.336ZM7.1693 9.11333L4.00264 5.94667L4.9453 5.00467L7.1693 7.22867L11.0593 3.338L12.0026 4.28133L7.1693 9.11333Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        PostgreSQL
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M13.6667 2.33333H3C2.82319 2.33333 2.65362 2.40357 2.5286 2.5286C2.40357 2.65362 2.33333 2.82319 2.33333 3V12.3333C2.33333 12.5101 2.40357 12.6797 2.5286 12.8047C2.65362 12.9298 2.82319 13 3 13H13.6667C13.8435 13 14.013 12.9298 14.1381 12.8047C14.2631 12.6797 14.3333 12.5101 14.3333 12.3333V3C14.3333 2.82319 14.2631 2.65362 14.1381 2.5286C14.013 2.40357 13.8435 2.33333 13.6667 2.33333ZM3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V12.3333C1 12.8638 1.21071 13.3725 1.58579 13.7475C1.96086 14.1226 2.46957 14.3333 3 14.3333H13.6667C14.1971 14.3333 14.7058 14.1226 15.0809 13.7475C15.456 13.3725 15.6667 12.8638 15.6667 12.3333V3C15.6667 2.46957 15.456 1.96086 15.0809 1.58579C14.7058 1.21071 14.1971 1 13.6667 1H3ZM4.33333 4.33333H5.66667V5.66667H4.33333V4.33333ZM7.66667 4.33333C7.48986 4.33333 7.32029 4.40357 7.19526 4.5286C7.07024 4.65362 7 4.82319 7 5C7 5.17681 7.07024 5.34638 7.19526 5.4714C7.32029 5.59643 7.48986 5.66667 7.66667 5.66667H11.6667C11.8435 5.66667 12.013 5.59643 12.1381 5.4714C12.2631 5.34638 12.3333 5.17681 12.3333 5C12.3333 4.82319 12.2631 4.65362 12.1381 4.5286C12.013 4.40357 11.8435 4.33333 11.6667 4.33333H7.66667ZM5.66667 7H4.33333V8.33333H5.66667V7ZM7 7.66667C7 7.48986 7.07024 7.32029 7.19526 7.19526C7.32029 7.07024 7.48986 7 7.66667 7H11.6667C11.8435 7 12.013 7.07024 12.1381 7.19526C12.2631 7.32029 12.3333 7.48986 12.3333 7.66667C12.3333 7.84348 12.2631 8.01305 12.1381 8.13807C12.013 8.26309 11.8435 8.33333 11.6667 8.33333H7.66667C7.48986 8.33333 7.32029 8.26309 7.19526 8.13807C7.07024 8.01305 7 7.84348 7 7.66667ZM5.66667 9.66667H4.33333V11H5.66667V9.66667ZM7 10.3333C7 10.1565 7.07024 9.98695 7.19526 9.86193C7.32029 9.7369 7.48986 9.66667 7.66667 9.66667H11.6667C11.8435 9.66667 12.013 9.7369 12.1381 9.86193C12.2631 9.98695 12.3333 10.1565 12.3333 10.3333C12.3333 10.5101 12.2631 10.6797 12.1381 10.8047C12.013 10.9298 11.8435 11 11.6667 11H7.66667C7.48986 11 7.32029 10.9298 7.19526 10.8047C7.07024 10.6797 7 10.5101 7 10.3333Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        Java Script
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M7.33203 10H8.66536V11.3334H7.33203V10ZM7.33203 4.66669H8.66536V8.66669H7.33203V4.66669Z"
                                          fill="#023047"
                                        />
                                        <path
                                          d="M3.33984 0.666687V15.3334H12.6665V0.666687H3.33984ZM11.3332 12H4.66651V4.00002H11.3332V12Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        React
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M13.6667 2.33333H3C2.82319 2.33333 2.65362 2.40357 2.5286 2.5286C2.40357 2.65362 2.33333 2.82319 2.33333 3V12.3333C2.33333 12.5101 2.40357 12.6797 2.5286 12.8047C2.65362 12.9298 2.82319 13 3 13H13.6667C13.8435 13 14.013 12.9298 14.1381 12.8047C14.2631 12.6797 14.3333 12.5101 14.3333 12.3333V3C14.3333 2.82319 14.2631 2.65362 14.1381 2.5286C14.013 2.40357 13.8435 2.33333 13.6667 2.33333ZM3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V12.3333C1 12.8638 1.21071 13.3725 1.58579 13.7475C1.96086 14.1226 2.46957 14.3333 3 14.3333H13.6667C14.1971 14.3333 14.7058 14.1226 15.0809 13.7475C15.456 13.3725 15.6667 12.8638 15.6667 12.3333V3C15.6667 2.46957 15.456 1.96086 15.0809 1.58579C14.7058 1.21071 14.1971 1 13.6667 1H3ZM4.33333 4.33333H5.66667V5.66667H4.33333V4.33333ZM7.66667 4.33333C7.48986 4.33333 7.32029 4.40357 7.19526 4.5286C7.07024 4.65362 7 4.82319 7 5C7 5.17681 7.07024 5.34638 7.19526 5.4714C7.32029 5.59643 7.48986 5.66667 7.66667 5.66667H11.6667C11.8435 5.66667 12.013 5.59643 12.1381 5.4714C12.2631 5.34638 12.3333 5.17681 12.3333 5C12.3333 4.82319 12.2631 4.65362 12.1381 4.5286C12.013 4.40357 11.8435 4.33333 11.6667 4.33333H7.66667ZM5.66667 7H4.33333V8.33333H5.66667V7ZM7 7.66667C7 7.48986 7.07024 7.32029 7.19526 7.19526C7.32029 7.07024 7.48986 7 7.66667 7H11.6667C11.8435 7 12.013 7.07024 12.1381 7.19526C12.2631 7.32029 12.3333 7.48986 12.3333 7.66667C12.3333 7.84348 12.2631 8.01305 12.1381 8.13807C12.013 8.26309 11.8435 8.33333 11.6667 8.33333H7.66667C7.48986 8.33333 7.32029 8.26309 7.19526 8.13807C7.07024 8.01305 7 7.84348 7 7.66667ZM5.66667 9.66667H4.33333V11H5.66667V9.66667ZM7 10.3333C7 10.1565 7.07024 9.98695 7.19526 9.86193C7.32029 9.7369 7.48986 9.66667 7.66667 9.66667H11.6667C11.8435 9.66667 12.013 9.7369 12.1381 9.86193C12.2631 9.98695 12.3333 10.1565 12.3333 10.3333C12.3333 10.5101 12.2631 10.6797 12.1381 10.8047C12.013 10.9298 11.8435 11 11.6667 11H7.66667C7.48986 11 7.32029 10.9298 7.19526 10.8047C7.07024 10.6797 7 10.5101 7 10.3333Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        Java Script
                                      </span>
                                    </button>
                                  </li>
                                </ul>

                                <p className="ct_para_scroll ct_custom_scroll ct_fS_16 ct_darkblue_text mt-4 mb-0">
                                  I specialize in both front-end and back-end
                                  development, and I’m passionate about solving
                                  complex problems and creating seamless,
                                  user-friendly solutions.
                                </p>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-12 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="d-flex align-items-center gap-4 justify-content-between ct_flex_col_767">
                                <div className="d-flex align-items-center gap-4 ct_flex_1 ct_flex_col_767 ">
                                  <div className=" ct_flex_shrink_0">
                                    <img
                                      src="../assets/img/user_22.png"
                                      className="ct_img_100"
                                    />
                                  </div>
                                  <div className="">
                                    <div className="ct_flex_1 d-flex align-items-center gap-md-5 gap-3 ct_flex_col_575">
                                      <div>
                                        <p className="ct_fs_16 mb-2 ct_darkblue_text">
                                          Alex Carter
                                        </p>
                                        <h4
                                          className="ct_fs_18 mb-0  ct_darkblue_text ct_overflow_text ct_para_scroll"
                                          style={{ maxHeight: "80px" }}
                                        >
                                          Certified WIX | Full-Stack Developer|
                                          2D Drawings
                                        </h4>
                                      </div>
                                      <div>
                                        <span
                                          className="ct_badge ct_fs_14 ct_white_nowrap ct_darkblue_text ct_h_35 d-flex align-items-center justify-content-center ct_fit_content gap-1 border-0"
                                          style={{
                                            backgroundColor:
                                              "hsl(32deg 100% 49% / 30%)",
                                          }}
                                        >
                                          <img
                                            class="ct_img_w_16 ms-2"
                                            src="../assets/img/noto_fire_12.png"
                                          />{" "}
                                          NuForge
                                        </span>
                                      </div>
                                    </div>
                                    <p className="d-flex align-items-center gap-2 ct_text_op_6 mb-0 mt-1 ct_fs_16 ct_darkblue_text">
                                      United States
                                    </p>
                                  </div>
                                </div>
                                <div className="pe-xl-5 ct_w_100_767">
                                  <button
                                    // data-bs-target="#ct_view_profile_modal"
                                    // data-bs-toggle="modal"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      openSignUp();
                                    }}
                                    className="ct_yellow_btn ct_h_40 ct_border_radius_8 border-0 ct_white_nowrap ct_w_100_767"
                                    style={{ backgroundColor: "#FFB703" }}
                                  >
                                    View Profile
                                  </button>
                                </div>
                              </div>
                              <figcaption className="mt-4">
                                <ul className="d-flex align-items-center gap-4 flex-wrap">
                                  <li>$100 / project</li>
                                  <li class="d-flex align-items-center gap-1">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        x="0.5"
                                        y="0.5"
                                        width="23"
                                        height="23"
                                        rx="11.5"
                                        stroke="#219EBC"
                                      />
                                      <path
                                        d="M7.9987 17.3333C7.80981 17.3333 7.65159 17.2693 7.52403 17.1413C7.39648 17.0133 7.33248 16.8551 7.33203 16.6666C7.33159 16.4782 7.39559 16.32 7.52403 16.192C7.65248 16.064 7.8107 16 7.9987 16H15.9987C16.1876 16 16.346 16.064 16.474 16.192C16.602 16.32 16.6658 16.4782 16.6654 16.6666C16.6649 16.8551 16.6009 17.0135 16.4734 17.142C16.3458 17.2704 16.1876 17.3342 15.9987 17.3333H7.9987ZM8.46537 15C8.14314 15 7.85714 14.8944 7.60737 14.6833C7.35759 14.4722 7.2047 14.2055 7.1487 13.8833L6.48203 9.64998C6.45981 9.64998 6.43492 9.65287 6.40737 9.65865C6.37981 9.66443 6.3547 9.66709 6.33203 9.66665C6.05425 9.66665 5.81825 9.56954 5.62403 9.37531C5.42981 9.18109 5.33248 8.94487 5.33203 8.66665C5.33159 8.38843 5.42892 8.15243 5.62403 7.95865C5.81914 7.76487 6.05514 7.66754 6.33203 7.66665C6.60892 7.66576 6.84514 7.76309 7.0407 7.95865C7.23626 8.1542 7.33337 8.3902 7.33203 8.66665C7.33203 8.74443 7.32359 8.81665 7.3067 8.88331C7.28981 8.94998 7.27048 9.01109 7.2487 9.06665L9.33203 9.99998L11.4154 7.14998C11.2931 7.06109 11.1931 6.94443 11.1154 6.79998C11.0376 6.65554 10.9987 6.49998 10.9987 6.33331C10.9987 6.05554 11.096 5.81931 11.2907 5.62465C11.4854 5.42998 11.7214 5.33287 11.9987 5.33331C12.276 5.33376 12.5123 5.43109 12.7074 5.62531C12.9025 5.81954 12.9996 6.05554 12.9987 6.33331C12.9987 6.49998 12.9598 6.65554 12.882 6.79998C12.8043 6.94443 12.7043 7.06109 12.582 7.14998L14.6654 9.99998L16.7487 9.06665C16.7265 9.01109 16.7069 8.94998 16.69 8.88331C16.6731 8.81665 16.6649 8.74443 16.6654 8.66665C16.6654 8.38887 16.7627 8.15265 16.9574 7.95798C17.152 7.76331 17.388 7.6662 17.6654 7.66665C17.9427 7.66709 18.1789 7.76443 18.374 7.95865C18.5691 8.15287 18.6663 8.38887 18.6654 8.66665C18.6645 8.94443 18.5674 9.18065 18.374 9.37531C18.1807 9.56998 17.9445 9.66709 17.6654 9.66665C17.6431 9.66665 17.6183 9.66398 17.5907 9.65865C17.5631 9.65331 17.538 9.65043 17.5154 9.64998L16.8487 13.8833C16.7931 14.2055 16.6405 14.4722 16.3907 14.6833C16.1409 14.8944 15.8547 15 15.532 15H8.46537Z"
                                        fill="#219EBC"
                                      />
                                    </svg>
                                    <span>100% Job Success</span>
                                  </li>
                                  <li>5+ years experience</li>
                                  <li>
                                    <button
                                      className="ct_badge border-0 gap-1"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                      }}
                                    >
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M2.82402 8.32107L8.27042 0.893869C8.39214 0.728109 8.56802 0.610152 8.76757 0.560436C8.96713 0.510719 9.17778 0.532376 9.36305 0.621652C9.54831 0.710929 9.69651 0.862202 9.78197 1.04926C9.86742 1.23632 9.88475 1.44738 9.83095 1.64587L8.62668 6.06294C8.61586 6.10249 8.6143 6.14401 8.62213 6.18427C8.62997 6.22453 8.64698 6.26244 8.67185 6.29505C8.69672 6.32766 8.72878 6.35409 8.76553 6.3723C8.80228 6.3905 8.84274 6.39998 8.88375 6.4H12.5317C12.6803 6.39994 12.8259 6.44108 12.9525 6.51883C13.0791 6.59658 13.1816 6.7079 13.2487 6.84042C13.3158 6.97294 13.3448 7.12147 13.3325 7.2695C13.3203 7.41753 13.2672 7.55926 13.1792 7.67894L7.73282 15.1072C7.61111 15.2732 7.4351 15.3914 7.23534 15.4412C7.03558 15.491 6.82469 15.4693 6.63928 15.3798C6.45387 15.2904 6.30564 15.1388 6.22034 14.9514C6.13503 14.7641 6.11803 14.5527 6.17228 14.3541L7.37655 9.93707C7.38738 9.89751 7.38893 9.85599 7.3811 9.81573C7.37327 9.77547 7.35625 9.73757 7.33138 9.70496C7.30651 9.67235 7.27445 9.64591 7.2377 9.62771C7.20095 9.6095 7.16049 9.60002 7.11948 9.6H3.47148C3.32295 9.60006 3.1773 9.55893 3.05074 9.48118C2.92418 9.40343 2.82166 9.29211 2.75457 9.15958C2.68748 9.02706 2.65845 8.87854 2.67071 8.73051C2.68297 8.58248 2.73604 8.44075 2.82402 8.32107Z"
                                          fill="#219EBC"
                                        />
                                      </svg>
                                      <span className="ct_darksky_blue_text ct_fs_12">
                                        Available now
                                      </span>
                                    </button>
                                  </li>
                                </ul>
                                <ul className="d-flex align-items-center gap-4 ct_mt_20 flex-wrap">
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M7.33203 10H8.66536V11.3334H7.33203V10ZM7.33203 4.66669H8.66536V8.66669H7.33203V4.66669Z"
                                          fill="#023047"
                                        />
                                        <path
                                          d="M3.33984 0.666687V15.3334H12.6665V0.666687H3.33984ZM11.3332 12H4.66651V4.00002H11.3332V12Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        Node.js
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M14.0013 1.336H2.0013C1.648 1.33705 1.30948 1.47787 1.05966 1.72769C0.809839 1.97751 0.669024 2.31603 0.667969 2.66933V10.6693C0.669024 11.0226 0.809839 11.3612 1.05966 11.611C1.30948 11.8608 1.648 12.0016 2.0013 12.0027H6.66797V13.336H5.33464V14.6693H10.668V13.336H9.33464V12.0027H14.0013C14.3546 12.0016 14.6931 11.8608 14.9429 11.611C15.1928 11.3612 15.3336 11.0226 15.3346 10.6693V2.66933C15.3336 2.31603 15.1928 1.97751 14.9429 1.72769C14.6931 1.47787 14.3546 1.33705 14.0013 1.336ZM7.1693 9.11333L4.00264 5.94667L4.9453 5.00467L7.1693 7.22867L11.0593 3.338L12.0026 4.28133L7.1693 9.11333Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        PostgreSQL
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M13.6667 2.33333H3C2.82319 2.33333 2.65362 2.40357 2.5286 2.5286C2.40357 2.65362 2.33333 2.82319 2.33333 3V12.3333C2.33333 12.5101 2.40357 12.6797 2.5286 12.8047C2.65362 12.9298 2.82319 13 3 13H13.6667C13.8435 13 14.013 12.9298 14.1381 12.8047C14.2631 12.6797 14.3333 12.5101 14.3333 12.3333V3C14.3333 2.82319 14.2631 2.65362 14.1381 2.5286C14.013 2.40357 13.8435 2.33333 13.6667 2.33333ZM3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V12.3333C1 12.8638 1.21071 13.3725 1.58579 13.7475C1.96086 14.1226 2.46957 14.3333 3 14.3333H13.6667C14.1971 14.3333 14.7058 14.1226 15.0809 13.7475C15.456 13.3725 15.6667 12.8638 15.6667 12.3333V3C15.6667 2.46957 15.456 1.96086 15.0809 1.58579C14.7058 1.21071 14.1971 1 13.6667 1H3ZM4.33333 4.33333H5.66667V5.66667H4.33333V4.33333ZM7.66667 4.33333C7.48986 4.33333 7.32029 4.40357 7.19526 4.5286C7.07024 4.65362 7 4.82319 7 5C7 5.17681 7.07024 5.34638 7.19526 5.4714C7.32029 5.59643 7.48986 5.66667 7.66667 5.66667H11.6667C11.8435 5.66667 12.013 5.59643 12.1381 5.4714C12.2631 5.34638 12.3333 5.17681 12.3333 5C12.3333 4.82319 12.2631 4.65362 12.1381 4.5286C12.013 4.40357 11.8435 4.33333 11.6667 4.33333H7.66667ZM5.66667 7H4.33333V8.33333H5.66667V7ZM7 7.66667C7 7.48986 7.07024 7.32029 7.19526 7.19526C7.32029 7.07024 7.48986 7 7.66667 7H11.6667C11.8435 7 12.013 7.07024 12.1381 7.19526C12.2631 7.32029 12.3333 7.48986 12.3333 7.66667C12.3333 7.84348 12.2631 8.01305 12.1381 8.13807C12.013 8.26309 11.8435 8.33333 11.6667 8.33333H7.66667C7.48986 8.33333 7.32029 8.26309 7.19526 8.13807C7.07024 8.01305 7 7.84348 7 7.66667ZM5.66667 9.66667H4.33333V11H5.66667V9.66667ZM7 10.3333C7 10.1565 7.07024 9.98695 7.19526 9.86193C7.32029 9.7369 7.48986 9.66667 7.66667 9.66667H11.6667C11.8435 9.66667 12.013 9.7369 12.1381 9.86193C12.2631 9.98695 12.3333 10.1565 12.3333 10.3333C12.3333 10.5101 12.2631 10.6797 12.1381 10.8047C12.013 10.9298 11.8435 11 11.6667 11H7.66667C7.48986 11 7.32029 10.9298 7.19526 10.8047C7.07024 10.6797 7 10.5101 7 10.3333Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        Java Script
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M7.33203 10H8.66536V11.3334H7.33203V10ZM7.33203 4.66669H8.66536V8.66669H7.33203V4.66669Z"
                                          fill="#023047"
                                        />
                                        <path
                                          d="M3.33984 0.666687V15.3334H12.6665V0.666687H3.33984ZM11.3332 12H4.66651V4.00002H11.3332V12Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        React
                                      </span>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="ct_badge d-flex align-items-center gap-1 px-3"
                                      style={{
                                        backgroundColor:
                                          "hsl(200deg 95% 14% / 5%)",
                                        borderColor: "hsl(200deg 95% 14% / 50%",
                                      }}
                                    >
                                      <svg
                                        className="ct_flex_shrink_0"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M13.6667 2.33333H3C2.82319 2.33333 2.65362 2.40357 2.5286 2.5286C2.40357 2.65362 2.33333 2.82319 2.33333 3V12.3333C2.33333 12.5101 2.40357 12.6797 2.5286 12.8047C2.65362 12.9298 2.82319 13 3 13H13.6667C13.8435 13 14.013 12.9298 14.1381 12.8047C14.2631 12.6797 14.3333 12.5101 14.3333 12.3333V3C14.3333 2.82319 14.2631 2.65362 14.1381 2.5286C14.013 2.40357 13.8435 2.33333 13.6667 2.33333ZM3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V12.3333C1 12.8638 1.21071 13.3725 1.58579 13.7475C1.96086 14.1226 2.46957 14.3333 3 14.3333H13.6667C14.1971 14.3333 14.7058 14.1226 15.0809 13.7475C15.456 13.3725 15.6667 12.8638 15.6667 12.3333V3C15.6667 2.46957 15.456 1.96086 15.0809 1.58579C14.7058 1.21071 14.1971 1 13.6667 1H3ZM4.33333 4.33333H5.66667V5.66667H4.33333V4.33333ZM7.66667 4.33333C7.48986 4.33333 7.32029 4.40357 7.19526 4.5286C7.07024 4.65362 7 4.82319 7 5C7 5.17681 7.07024 5.34638 7.19526 5.4714C7.32029 5.59643 7.48986 5.66667 7.66667 5.66667H11.6667C11.8435 5.66667 12.013 5.59643 12.1381 5.4714C12.2631 5.34638 12.3333 5.17681 12.3333 5C12.3333 4.82319 12.2631 4.65362 12.1381 4.5286C12.013 4.40357 11.8435 4.33333 11.6667 4.33333H7.66667ZM5.66667 7H4.33333V8.33333H5.66667V7ZM7 7.66667C7 7.48986 7.07024 7.32029 7.19526 7.19526C7.32029 7.07024 7.48986 7 7.66667 7H11.6667C11.8435 7 12.013 7.07024 12.1381 7.19526C12.2631 7.32029 12.3333 7.48986 12.3333 7.66667C12.3333 7.84348 12.2631 8.01305 12.1381 8.13807C12.013 8.26309 11.8435 8.33333 11.6667 8.33333H7.66667C7.48986 8.33333 7.32029 8.26309 7.19526 8.13807C7.07024 8.01305 7 7.84348 7 7.66667ZM5.66667 9.66667H4.33333V11H5.66667V9.66667ZM7 10.3333C7 10.1565 7.07024 9.98695 7.19526 9.86193C7.32029 9.7369 7.48986 9.66667 7.66667 9.66667H11.6667C11.8435 9.66667 12.013 9.7369 12.1381 9.86193C12.2631 9.98695 12.3333 10.1565 12.3333 10.3333C12.3333 10.5101 12.2631 10.6797 12.1381 10.8047C12.013 10.9298 11.8435 11 11.6667 11H7.66667C7.48986 11 7.32029 10.9298 7.19526 10.8047C7.07024 10.6797 7 10.5101 7 10.3333Z"
                                          fill="#023047"
                                        />
                                      </svg>

                                      <span className="ct_darkblue_text ct_fs_14 ms-1 text-start">
                                        Java Script
                                      </span>
                                    </button>
                                  </li>
                                </ul>

                                <p className="ct_para_scroll ct_custom_scroll ct_fS_16 ct_darkblue_text mt-4 mb-0">
                                  I specialize in both front-end and back-end
                                  development, and I’m passionate about solving
                                  complex problems and creating seamless,
                                  user-friendly solutions.
                                </p>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              class="ct_looking_for_work_bg  ct_mt_100    ct_p_111_y_106"
              style={{ backgroundColor: "var(--orange)" }}
            >
              <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                <div class="text-white">
                  <h4 class="ct_fs_36 mb-4">Unlock your potential.</h4>
                  <p class="mb-0 ct_fs_18">
                    Join a community of top IT professionals and access
                    high-value projects worldwide.
                  </p>
                </div>
                <div class="ct_flex_shrink_0">
                  <a
                    class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                    onClick={openSignUp}
                  >
                    Join Us
                  </a>
                </div>
              </div>
            </section>

            <section className="ct_px_40 ct_py_130 ct_pb_100">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <h2 className="ct_fs_32 text-center mb-0">
                      Discover Exceptional Freelancers
                    </h2>
                  </div>
                </div>
                <div
                  className="row ct_mt_60"
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={5}
                    autoHeight={false}
                    navigation
                    // autoplay={{ delay: 2500 }}
                    // loop={true}
                    breakpoints={{
                      0: { slidesPerView: 1 },
                      576: { slidesPerView: 2 },
                      768: { slidesPerView: 4 },
                      1200: { slidesPerView: 5 },
                    }}
                    className="ct_coach_created_slider"
                  >
                    <SwiperSlide>
                      <div className="item">
                        <figure className="ct_featured_coach_card">
                          <div className="ct_featured_card_img">
                            <img
                              src="../assets/img/Featured_Coaches_img_4.jpg"
                              alt=""
                            />
                          </div>
                          <figcaption>
                            <h4 className="ct_fs_20  mb-1">Jeffrey Walters</h4>
                            <p className="mb-0 ct_grey_text">Founder Coach</p>
                          </figcaption>
                        </figure>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="item">
                        <figure className="ct_featured_coach_card">
                          <div className="ct_featured_card_img">
                            <img
                              src="../assets/img/Featured_Coaches_img_2.jpg"
                              alt=""
                            />
                          </div>
                          <figcaption>
                            <h4 className="ct_fs_20  mb-1">Joe Bridges</h4>
                            <p className="mb-0 ct_grey_text">
                              Leadership Coach
                            </p>
                          </figcaption>
                        </figure>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide>
                      <div className="item">
                        <figure className="ct_featured_coach_card">
                          <div className="ct_featured_card_img">
                            <img
                              src="../assets/img/Featured_Coaches_img_10.png"
                              alt=""
                            />
                          </div>
                          <figcaption>
                            <h4 className="ct_fs_20  mb-1">Nellie Padilla</h4>
                            <p className="mb-0 ct_grey_text">Personal Coach</p>
                          </figcaption>
                        </figure>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="item">
                        <figure className="ct_featured_coach_card">
                          <div className="ct_featured_card_img">
                            <img
                              src="../assets/img/Featured_Coaches_img_4.jpg"
                              alt=""
                            />
                          </div>
                          <figcaption>
                            <h4 className="ct_fs_20  mb-1">Jeffrey Walters</h4>
                            <p className="mb-0 ct_grey_text">Founder Coach</p>
                          </figcaption>
                        </figure>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="item">
                        <figure className="ct_featured_coach_card">
                          <div className="ct_featured_card_img">
                            <img
                              src="../assets/img/Featured_Coaches_img_5.jpg"
                              alt=""
                            />
                          </div>
                          <figcaption>
                            <h4 className="ct_fs_20  mb-1">Dean Bell</h4>
                            <p className="mb-0 ct_grey_text">Frontend Coach</p>
                          </figcaption>
                        </figure>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </section>

            <section
              className="ct_px_40  pb-0"
              data-aos="fade-down"
              data-aos-duration="1500"
            >
              <div className="container-fluid">
                {/* convert into slider */}
                <div className="row">
                  <div className="col-lg-4 col-md-6 mb-4">
                    <div class="ct_testimonial_review_card h-100 d-grid">
                      <div>
                        <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                          <div class="d-flex align-items-center gap-1">
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          </div>
                          <p className="mb-0 ct_fs_16">20th April, 2025</p>
                        </div>
                        <p className="mb-0 " style={{ maxWidth: "295px" }}>
                          The expert sessions and networking inside NuForge are next level. I finally feel part of a serious community that pushes me to grow.
                        </p>
                      </div>
                      <div className="mt-auto">
                        <div class="d-flex align-items-center gap-3 ct_mt_40">
                          <img
                            src="/assets/img/Ellipse 24.png"
                            class="ct_img_60 "
                            alt=""
                          />
                          <div>
                            <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                              Alex Robertson
                            </h5>
                            <p class="mb-0  ct_fs_16  ">Frontend Developer</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <div class="ct_testimonial_review_card h-100 d-grid">
                      <div>
                        <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                          <div class="d-flex align-items-center gap-1">
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          </div>

                          <p className="mb-0 ct_fs_16">20th April, 2025</p>
                        </div>
                        <p className="mb-0 " style={{ maxWidth: "295px" }}>
                          With NuForge, I refined my services, rebranded my profile, and doubled my client reach in just a few weeks. Totally worth it!
                        </p>
                      </div>
                      <div className="mt-auto">
                        <div class="d-flex align-items-center gap-3 ct_mt_40">
                          <img
                            src="/assets/img/Ellipse 24 (1).png"
                            class="ct_img_60 "
                            alt=""
                          />
                          <div>
                            <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                              Olivia Brooks
                            </h5>
                            <p class="mb-0  ct_fs_16  ">Mobile App Developer</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <div class="ct_testimonial_review_card h-100 d-grid">
                      <div>
                        <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                          <div class="d-flex align-items-center gap-1">
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                            <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          </div>

                          <p className="mb-0 ct_fs_16">20th April, 2025</p>
                        </div>
                        <p className="mb-0 " style={{ maxWidth: "295px" }}>
                          NuForge helped me position myself for higher-paying clients by improving my portfolio and strategy.
                        </p>
                      </div>
                      <div className="mt-auto">
                        <div class="d-flex align-items-center gap-3 ct_mt_40">
                          <img
                            src="/assets/img/Ellipse 24 (2).png"
                            class="ct_img_60 "
                            alt=""
                          />
                          <div>
                            <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                              James Thornton
                            </h5>
                            <p class="mb-0  ct_fs_16  ">Cloud Solutions Architect</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              class="ct_looking_for_work_bg ct_looking_for_work_bg_left  ct_mt_100    ct_p_111_y_106"
              style={{ backgroundColor: "#219EBC" }}
            >
              <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                <div class="text-white">
                  <h4 class="ct_fs_36 mb-4 ct_darkblue_text">
                    Built for Your Growth
                  </h4>
                  <p class="mb-0 ct_fs_18" style={{ maxWidth: "631px" }}>
                    Shaped by your insights, our platform evolves with your
                    needs—helping you scale smarter at every stage.
                  </p>
                </div>
                <div class="ct_flex_shrink_0">
                  <a
                    class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(coachPaths?.WebinarLandingPage);
                    }}
                  >
                    Get Coached
                  </a>
                </div>
              </div>
            </section>

            <section class=" ct_px_40 pt-0 ct_mt_100 ct_faq_section_shape_yellow">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div class="col-xxl-4  col-xl-5 col-md-6 mb-4 mb-md-0  ">
                    <div class="ct_about_img mb-4">
                      <img
                        src="../assets/img/hire_talent_faq_left.png"
                        class="ct_img_h_579"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 ps-xl-5">
                    <div class="ct_about_cnt ">
                      <h2 class=" ct_fs_32  mb-4 ct_darksky_blue_text">
                        Frequently asked questions
                      </h2>

                      <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                        <div class="accordion" id="faq_accordionExample">
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faq_one">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_one"
                                aria-expanded="false"
                                aria-controls="collapsefaq_one"
                              >
                                How do I post a job on NUVIO?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_one"
                              class="accordion-collapse collapse"
                              aria-labelledby="faq_one"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Sign up for an account, complete your profile,
                                  and browse our directory of coaches. You can
                                  filter by expertise, experience, and coaching
                                  style to find the best match for your needs.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqtwo">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Two"
                                aria-expanded="true"
                                aria-controls="collapseTwo"
                              >
                                What kind of talent can I find on NUVIO?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Two"
                              class="accordion-collapse collapse "
                              aria-labelledby="faqtwo"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  NUVIO offers a wide range of coaching,
                                  including career coaching, business and
                                  entrepreneurship coaching, creative and design
                                  coaching, personal development, and
                                  skills-specific coaching like Creative AI or
                                  freelance growth.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqthree">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Three"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Three"
                              >
                                How does NUVIO match talent to my job post?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Three"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqthree"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Once you’ve found a coach that fits your
                                  needs, you can book a session directly through
                                  their profile. Choose a time that works for
                                  you, confirm your booking, and receive a
                                  session link or meeting details.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqFour">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Four"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Four"
                              >
                                Can I hire for long-term or short-term roles?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Four"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqFour"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Review the coach’s profile, experience, and
                                  specialties. Many coaches offer introductory
                                  calls or discovery sessions so you can assess
                                  compatibility before committing to a full
                                  program.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqFive">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Five"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Five"
                              >
                                What if the freelancer isn’t a good fit?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Five"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqFive"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Yes! You can send a message or schedule a
                                  short consultation to discuss your goals and
                                  see if the coach is the right fit before
                                  booking a full session.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqSix">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Six"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Six"
                              >
                                Can I communicate directly with freelancers
                                before hiring?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Six"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqSix"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Yes! You can send a message or schedule a
                                  short consultation to discuss your goals and
                                  see if the coach is the right fit before
                                  booking a full session.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqSeven">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Seven"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Seven"
                              >
                                Can I hire multiple freelancers for the same
                                project?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Seven"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqSeven"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Yes! You can send a message or schedule a
                                  short consultation to discuss your goals and
                                  see if the coach is the right fit before
                                  booking a full session.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqEight">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Eight"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Eight"
                              >
                                What’s the cost of using NUVIO?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Eight"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqEight"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Yes! You can send a message or schedule a
                                  short consultation to discuss your goals and
                                  see if the coach is the right fit before
                                  booking a full session.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </MenuLayout>

      <div
        className="modal modal-xl ct_congratulation_modal_fade"
        id="ct_job_details_modal"
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered ct_modal-dialog"
          style={{ maxWidth: "1440px" }}
        >
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close ct_circle_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body px-sm-5 px-3 pt-0 pb-5">
              <div className="row">
                <div className="col-xl-8 col-lg-8 mb-4 mb-lg-0">
                  <div className="">
                    <div className="d-flex align-items-start justify-content-between gap-3 ct_flex_col_1199  ct_mb_60">
                      <div>
                        <h4 className="ct_fs_32 mb-0 ct_darkblue_text">
                          UI/UX Designer
                        </h4>
                        <div className="d-flex align-items-center gap-3  mt-4 ct_flex_col_575">
                          <div
                            class="ct_feature_job_icon"
                            style={{ width: "80px", height: "80px" }}
                          >
                            <img src="assets/img/Featured_Jobs_icon_1.svg" />
                          </div>
                          <div>
                            <div className="d-flex align-items-center gap-3 ">
                              <h4 className="ct_fs_18 mb-0 ct_darksky_blue_text">
                                CodeNest{" "}
                              </h4>
                              <div class="ct_fs_14 d-flex align-items-center gap-1">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                    fill="#023047"
                                  ></path>
                                </svg>
                                London, England
                              </div>
                            </div>
                            <div class="d-flex align-items-center gap-4 ct_mt_20 flex-wrap">
                              <span
                                class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{
                                  backgroundColor: "hsl(0deg 0% 93% / 50%)",
                                }}
                              >
                                Full-Time
                              </span>
                              <span
                                class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{
                                  backgroundColor: "hsl(0deg 0% 93% / 50%)",
                                }}
                              >
                                Remote
                              </span>
                              <span
                                class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{
                                  backgroundColor: "hsl(0deg 0% 93% / 50%)",
                                }}
                              >
                                2-4 Years
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center  gap-3 ">
                        <button
                          className="ct_yellow_btn ct_sky_blue_btn ct_white_nowrap ct_border_radius_20 ct_h_44 px-5"
                          data-bs-target="#ct_aaply_for_job"
                          data-bs-toggle="modal"
                        >
                          Apply Now
                        </button>
                        <div className="ct_icon_heart_50">
                          <i class="fa-regular fa-bookmark ct_darkblue_text"></i>
                        </div>
                        <div className="ct_icon_heart_50">
                          <i class="fa-solid fa-share-nodes ct_darkblue_text"></i>
                        </div>
                      </div>
                    </div>
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      About this role
                    </h4>
                    <p
                      className="ct_fs_20_new ct_para_scroll ct_custom_scroll ct_darkblue_text"
                      style={{ maxWidth: "820px" }}
                    >
                      As a UI/UX designer on CodeNest, you’ll focus on design
                      user- friendly on several platform (web, mobile,
                      dashboards, etc) to our user needs. Your innovation
                      solution will enhance the user experience on several
                      platforms. Join us and let’s making impact on user
                      engagement at CodeNest.
                    </p>
                  </div>
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Qualification
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      <li className="ct_fs_20_new ct_darkblue_text">
                        At least 2-4 years of relevant experience in product
                        design or related roles.
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Knowledge of design validation, either through
                        quantitative or qualitative research.
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Have good knowledge using Figma and Figjam
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Experience with analytics tools to gather data from
                        users
                      </li>
                    </ul>
                  </div>
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Responsibility
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      <li className="ct_fs_20_new ct_darkblue_text">
                        Create design and user journey on every features and
                        product/business units across multiple devices (Web
                        +App)
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Identifying design problems through user journey and
                        devising elegant solutions
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Develop low and hi fidelity designs, user experience
                        flow, & prototype, translate it into highly- polished
                        visual composites following style and brand guidelines
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Brainstorm and works together with Design Lead, UX
                        Engineers, and PMS to execute a design sprint on
                        specific story or task
                      </li>
                    </ul>
                  </div>
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Requirement
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      <li className="ct_fs_20_new ct_darkblue_text">
                        Proven work experience as a UI/UX Designer or similar
                        role
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Strond portfolio of design projects (web/ mobile)
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Proficiency in design and prototyping tools such as
                        Figma, Adobe XD, Sketch, or similar
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Good understanding of HTML/CSS (Knowledge of front-end
                        development is a plus)
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Ability to think creatively and deliver within deadlines
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Excellent communication and teamwork skills
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 mb-4 mb-lg-0 ps-lg-5">
                  <div>
                    <h4 className="ct_fs_24_new mb-4">Similar Jobs</h4>
                    <ul>
                      <li>
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="assets/img/Featured_Jobs_icon_6.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Lead UI Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_20">
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="assets/img/Featured_Jobs_icon_3.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Sr. UX Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_20">
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="assets/img/Featured_Jobs_icon_2.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Jr. UI Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="ct_mt_56">
                    <h4 className="ct_fs_24_new mb-4">
                      Other Jobs From CodeNest
                    </h4>
                    <ul>
                      <li>
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="assets/img/Featured_Jobs_icon_1.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Lead UI Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_20">
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="assets/img/Featured_Jobs_icon_1.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Sr. UX Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_20">
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="assets/img/Featured_Jobs_icon_1.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Jr. UI Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal modal-lg ct_congratulation_modal_fade"
        id="ct_view_profile_modal"
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered ct_modal-dialog"
          style={{ maxWidth: "663px" }}
        >
          <div className="modal-content ct_px_100 ct_border_radius_20">
            <div className="modal-header border-0 py-0">
              <button
                type="button"
                className="btn-close ct_circle_close ct_close_position_right12"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body px-0 ct_mt_60 pt-0 pb-5">
              <div className="d-flex align-items-center gap-3">
                <img
                  src="../assets/img/user_33.png"
                  className="ct_img_80 ct_flex_shrink_0"
                />
                <div>
                  <h4 className="ct_fs_20 ct_mb_16 ct_darkblue_text">
                    Connect with Alex Carter
                  </h4>
                  <p class="mb-0 ct_fs_16 ct_darkblue_text">Available</p>
                </div>
              </div>
              <div class="d-flex align-items-center gap-2 ct_mt_30">
                <label class="toggle-switch ct_toggle_switch_yellow">
                  <input type="checkbox" />
                  <div class="toggle-switch-background">
                    <div class="toggle-switch-handle"></div>
                  </div>
                </label>
                Contract
              </div>
              <form className="ct_modal_scroll ct_custom_scroll  pb-3 ct_mt_40 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Project Details
                      </label>
                      <textarea
                        className="form-control ct_input h-auto"
                        rows={4}
                        placeholder="Type here..."
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Target Date
                      </label>
                      <input
                        type="date"
                        className="form-control ct_input"
                        style={{ height: "60px" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Project Budget
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Project budget"
                        style={{ height: "60px" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3 justify-content-center pt-4 ct_flex_col_575">
                  <button
                    className="ct_sky_blue_btn ct_yellow_btn ct_outline_yellow_new  px-5 py-3 ct_w_100_575"
                    style={{
                      borderColorL: "#53586252",
                      color: "var(--yellow)",
                    }}
                    type="button"
                  >
                    Send Proposal
                  </button>
                  <button
                    className="ct_yellow_btn px-5 py-3 ct_w_100_575"
                    data-bs-target="#ct_hire_pay_modal"
                    data-bs-toggle="modal"
                    type="button"
                  >
                    Hire for 600$
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal modal-lg ct_congratulation_modal_fade "
        id="ct_hire_pay_modal"
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered ct_modal-dialog"
          style={{ maxWidth: "903px" }}
        >
          <div className="modal-content ct_pl_50_pr_94 ct_border_radius_20">
            <div className="modal-header border-0 py-0">
              <button
                type="button"
                className="btn-close ct_circle_close ct_close_position_right12"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body px-0 ct_mt_60 pt-0 pb-5">
              <div className="row gx-5">
                <div className="col-lg-6 mb-4 mb-lg-0">
                  <div className="d-flex align-items-center gap-3">
                    <img
                      src="../assets/img/user_33.png"
                      className="ct_img_80 ct_flex_shrink_0"
                    />
                    <div>
                      <h4 className="ct_fs_20 ct_mb_16 ct_darkblue_text">
                        Hire Alex Carter
                      </h4>
                      <p class="mb-0 ct_fs_16 ct_darkblue_text">
                        Full Stack Developer
                      </p>
                    </div>
                  </div>
                  <div className="ct_mt_50">
                    <table className="table ct_transparent_table">
                      <tbody>
                        <tr>
                          <td className="py-1">Subtotal</td>
                          <td className="text-end py-1">600 $</td>
                        </tr>
                        <tr>
                          <td className="pt-1 pb-3">Tax (15%)</td>
                          <td className="text-end pt-1 pb-3">90 $</td>
                        </tr>
                      </tbody>
                      <tfoot style={{ borderTop: "1px solid #CDCDCD" }}>
                        <tr>
                          <td className="pt-3">Total</td>
                          <td className="text-end pt-3 pb-0">690 $</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div className="ct_mt_50">
                    <h5 className="ct_fs_14 ct_darkblue_text mb-2">
                      Project Description
                    </h5>
                    <p className="ct_para_scroll ct_custom_scroll ct_fs_14 mb-0">
                      Develop a fully functional e-commerce website with
                      shopping cart, payment gateway integration, and product
                      management system.
                    </p>
                  </div>
                  <div className="ct_mt_30">
                    <h4 className="mb-1 ct_fs_14 ct_darkblue_text">
                      Target Date
                    </h4>
                    <p className="mb-0 ct_fs_14 ct_darkblue_text">
                      May 30, 2025
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 mb-4 mb-lg-0">
                  <div>
                    <h4 className="ct_fs_20 ct_darkblue_text ct_mb_20">
                      Payment Details
                    </h4>
                    <div className="ct_outline_dash_border">
                      <p className="mb-0 ct_fs_12">Payment Method</p>
                      <div className="d-flex align-items-center gap-2">
                        <img src="../assets/img/Mastercard_circle_icon.png" />
                        <img src="../assets/img/Visa_circle_icon.png" />
                        <img src="../assets/img/American_circle_icon.png" />
                        <img src="../assets/img/Discover_circle_icon.png" />
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-md-12">
                        <div className="form-group ct_mb_20">
                          <label className="ct_fs_14 mb-2">Name on card</label>
                          <input
                            type="text"
                            className="form-control ct_input ct_h_48"
                            placeholder="Name on card"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group ct_mb_20">
                          <label className="ct_fs_14 mb-2">Card number</label>
                          <input
                            type="number"
                            className="form-control ct_input ct_h_48"
                            placeholder="0000 0000 0000 0000"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group ">
                          <label className="ct_fs_14 mb-2">
                            Card expiration
                          </label>
                          <div className="row">
                            <div className="col-md-6 ct_mb_20">
                              <select className="form-control ct_input ct_h_48">
                                <option>Month</option>
                              </select>
                            </div>
                            <div className="col-md-6 ct_mb_20">
                              <select className="form-control ct_input ct_h_48">
                                <option>Year</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group ">
                          <label className="ct_fs_14 mb-2">
                            Card Security Code
                          </label>
                          <input
                            type="text"
                            className="form-control ct_input ct_h_48"
                            placeholder="Code"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="ct_mt_30">
                      <button
                        className="ct_yellow_btn w-100"
                        data-bs-target="#ct_hire_continue"
                        data-bs-toggle="modal"
                      >
                        Continue
                      </button>
                    </div>
                    <p className="ct_fs_12 ct_darkblue_text ct_mt_30 text-center">
                      Funds are only released once the work is completed and
                      approved by you, ensuring a risk-free transaction for both
                      parties.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal modal-lg ct_congratulation_modal_fade "
        id="ct_hire_continue"
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered ct_modal-dialog"
          style={{ maxWidth: "640px" }}
        >
          <div className="modal-content ct_px_30 ct_border_radius_20">
            <div className="modal-header border-0 py-0">
              <button
                type="button"
                className="btn-close ct_circle_close ct_close_position_right12"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body px-0 ct_mt_60 pt-0 pb-5">
              <div className="row gx-5 pt-4">
                <div className="col-lg-5 mb-4 mb-lg-0">
                  <div className="d-flex align-items-center gap-3">
                    <img
                      src="../assets/img/user_33.png"
                      className="ct_img_80 ct_flex_shrink_0"
                    />
                    <div>
                      <h4 className="ct_fs_14 ct_mb_16 ct_darkblue_text">
                        Alex Carter
                      </h4>
                      <p class="mb-0 ct_fs_12 ct_darkblue_text">
                        Full Stack Developer
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 mb-4 mb-lg-0">
                  <div>
                    <h6 className="ct_fs_14 ct_darkblue_text mb-1">
                      What Happens Next?
                    </h6>
                    <p className="ct_grey_text ct_fs_14">
                      You can now communicate with Alex to discuss details and
                      expectations.{" "}
                    </p>
                    <p className="ct_grey_text ct_fs_14 ct_mt_40 mb-0">
                      You can manage your project, review updates, and
                      communicate with your freelancer from your dashboard.
                    </p>
                    <div className="ct_mt_30">
                      <button className="ct_yellow_btn ct_h_44 px-5">
                        Go To Dashboard
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchTalentHire;
